import React, { Component } from 'react'
import Select from 'react-select'
import { TextBox, TextArea, SubmitButton } from '../../Components/InputElements'
import axios from 'axios'
import Swal from 'sweetalert2'
import withRouter from '../../Utils/withRouter'
import { ConfigContext } from '../../Context/ConfigContext'
import { NoRecords } from '../../Components/Shimmer';
import copy from 'clipboard-copy';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { calculateAge, currentDateAndTime, formatDateWithTime, offerLetterCheatCode, renderPages,createPages, decodeData, genderOptions, titleOptions } from '../../Constants/constants'
import { NavLink } from 'react-router-dom'
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";
class GuestEmployeeSandBox extends Component {
  static contextType = ConfigContext
  constructor (props) {
    super(props)

    this.state = {
      // Candidate Details //////
      employee_id: 0,
      guest_employee_id: 0,
      location_id: 0,
      From_date: '',
      To_date: '',
      referenceCode: '',
      Title: 'Mr.',
      employee_gender: 'Male',
      Date_of_birth: '',
      employee_joining_date: '',
      Designation: [],
      Grade: [],
      Department: [],
      Location: [],
      SelectLevels: '',
      LinkValidDays: '',
      employee_name: '',
      employee_email_address: '',
      employee_mobile_number: '',
      employee_address: '',
      designation_id: '',
      department_id: '',
      grade_id: '',
      letterEdit:false,
      emailEdit:false,
      required_documents: [],
      required_letters: [],
      rows: [],
      letter_Options: [],
      letter_rows: [],
      email_Options: [],
      email_rows: [],
      selectedSalaryType: null,
      allowances: [],
      statutoryList: [],
      statutoryOptions: [],
      signatoryRows: [],
      employee_contribution: '',
      employer_contribution: '',
      salary_heads_rows: [],
      company_salary_statutory_rows: [],
      company_salary_head_id: null,
      amount: '',
      ctc: '',
      rememberMe: false,
      documentMe: false,
      fixedHeads: [],
      mailTemplateTitle:"",
      mailSubject:"",
      mailBody:"",
      isEmailModal:"",
      infoLoading:"",
      shareSalary:"",
      shareCtc:"",
      selectedEmailTemplate:"",
      selectedLetterTemplate:"",
      selectedSignatoryTemplate:"",
      is_contract_employee:"0",
      isLetterModal:false,
      company_letter_head_id: "",
      company_letter_title: "",
      company_letter_head: [],
      company_letter_content: "",
      letter_preview: "",
      email_preview: "",
      markings: "0,0,0,0",
      letterhead_url: null,
      previewClicked: false,
      emailPreviewClicked: false,
      letter_next: false,
      letter_prev: false,
      letter_page: 1,
      letter_limit: 10,
      letter_total_records: 0,
      letter_total_pages: 0,
      email_next: false,
      email_prev: false,
      email_page: 1,
      email_limit: 10,
      email_total_records: 0,
      email_total_pages: 0,
      loadingList:false,
      loadingInfo:false,
      state_options:[],
      state_id:"",
      employee_type_row:[],
      employee_category_row:[],
      company_employee_type_id:"",
      company_employee_category_id:"",
      pdfPages:[],
      decodedData:[],
      letterIndex:'',
      emailIndex:'',
      errors:{},
      effective_date:"",
      save_as_draft: false,
      
    }
    this.handleSelect = this.handleSelect.bind(this)
  }

  componentDidMount () {
    const queryParams = new URLSearchParams(window.location.search);
    const draftLetterId = queryParams.get("data");

    console.log('draftLetterId',draftLetterId);
    this.setState({ loadingList: true, guest_employee_id: draftLetterId || 0 }, prevState => {
      
      if(this.state.guest_employee_id){
        this.GetLetterHeadsList()
        this.getSalaryHeadList()
        this.GetSalaryHeadList();
        this.getSignatoryTemplateList();
        // this.GetCompanyLetters();
        this.GetSalaryStatutoryList();
        this.GetListEmployeeDocumentType();
        this.getStateAndDesignation();
        this.GetDesignationMasters();
        this.GetGradeMasters();
        this.GetDepartmentMasters();
        this.GetLocationMasters();
        this.GetEmployeesTypeList();
        this.GetEmployeesCategoryList(); 
        this.getGuestEmployeeInfo();
      }
      else{
        this.getSalaryHeadList()
        this.getEmailTemplateList()
        this.getLetterTemplateList()
        this.GetLetterHeadsList()
        this.GetSalaryHeadList()
        this.getSignatoryTemplateList()
        // this.GetCompanyLetters()
        this.GetSalaryStatutoryList()
        this.GetListEmployeeDocumentType()
        this.getStateAndDesignation();
        this.GetDesignationMasters()
        this.GetGradeMasters()
        this.GetDepartmentMasters()
        this.GetLocationMasters()
        this.GetEmployeesTypeList();
        this.GetEmployeesCategoryList();
      }
    })
  }
  componentDidUpdate(prevProps, prevState) {
      if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
          const { permissions } = this.context;
          if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
              this.setState({ decodedData });
            }
          } else {
            console.warn("Permissions not yet available. Retrying...");
          }
      }
    }
  getList = async () => {
    const { apiURL, apiHeaderJSON } = this.context
    const headers = apiHeaderJSON
    axios
      .get(`${apiURL}Payrolls/GetSalaryHeadList`, {
        params: { guest_employee_id: 1000, },
        headers
      })
      .then(response => {
        // console.log(response?.data);
        const {success, data} = response?.data;
        if (success === true) {
          this.setState({ 
            guest_employee_id: 0,
            referenceCode: '',
            Title: 'Mr.',
            employee_name: '',
            employee_mobile_number: '',
            employee_email_address: '',
            employee_gender: 'Male',
            Date_of_birth: '',
            is_contract_employee:"0",
            From_date: '',
            To_date: '',
            state_id: 0,
            location_id: 0,
            department_id: 0,
            designation_id: 0,
            grade_id: 0,
            company_employee_type_id: 0,
            company_employee_category_id: 0,
            employee_joining_date: '',
            employee_address: '',
            effective_date:"",
            allowances: [],
            selectedLetterTemplate:"",
            selectedSignatoryTemplate:"",
            company_letter_content: "",
            letterhead_url: null,
            markings: "0,0,0,0",
            company_letter_title: '',
            company_letter_head_id: 0,
            isLetterModal: false,
            letter_rows: [],
            isEmailModal: false,
            selectedEmailTemplate:"",
            mailTemplateTitle: '',
            mailSubject: '',
            mailBody: '',
            email_rows: [],
            shareSalary:"",
            shareCtc:"",
            //---------------------------------------------------------------
            guest_employee_data: false,
            letterEdit:false,
            emailEdit:false,
            errors:{},
            
           })
        }
      })
      .catch((error) => {
        console.error('error', error);

      })
  }

  // getIndexByValue = (value) => {
  //   const result = templates.find(item => item.value === value);
  //   return result ? result.index : 0; // 0 if not found
  // }

  getGuestEmployeeInfo = async () => {
    const { apiURL, apiHeaderJSON } = this.context
    const headers = apiHeaderJSON
    this.setState({ loadingInfo: true });
    axios
      .get(`${apiURL}Employees/GetOfferLetterInfo`, {
        params: {
          guest_employee_id: this.state.guest_employee_id
        },
        headers
      })
      .then(response => {
        const {data, success} = response.data;
        // console.log(response?.data)
        if (success === true) {
          this.setState({ guest_employee_data: data,

              // reference_code:data?.guest_employee_personal?.referenceCode,
              Title: data?.guest_employee_personal?.employee_title,
              employee_name: data?.guest_employee_personal?.employee_name,
              employee_mobile_number: data?.guest_employee_personal?.employee_mobile_number,
              employee_email_address: data?.guest_employee_personal?.employee_email_address,
              employee_gender: data?.guest_employee_personal?.employee_gender,
              Date_of_birth: data?.guest_employee_personal?.date_of_birth,
              is_contract_employee: data?.guest_employee_personal?.is_contract_employee,
              From_date: data?.guest_employee_personal?.employee_from_date,
              To_date: data?.guest_employee_personal?.employee_to_date,
              location_id: data?.guest_employee_personal?.location_id,
              department_id: data?.guest_employee_personal?.department_id,
              designation_id: data?.guest_employee_personal?.designation_id,
              grade_id: data?.guest_employee_personal?.grade_id,
              employee_joining_date: data?.guest_employee_personal?.employee_joining_date,
              employee_address: data?.guest_employee_personal?.employee_address,
              state_id: data?.guest_employee_personal?.employee_state && parseInt(data?.guest_employee_personal?.employee_state),
              company_employee_type_id: data?.guest_employee_personal?.employee_type && parseInt(data?.guest_employee_personal?.employee_type),
              company_employee_category_id: data?.guest_employee_personal?.employee_category && parseInt(data?.guest_employee_personal?.employee_category),
              // effective_date: data?.guest_employee_salary?.length > 0 && data?.guest_employee_salary[0]?.effective_date,
              // effective_date: this.state.effective_date,
              // signatory_id: this.state.selectedSignatoryTemplate?.value || "",
              allowances: data?.guest_employee_salary,
              selectedLetterTemplate: data?.guest_employee_letter[data?.guest_employee_letter?.length - 1]?.company_letter_id ,
              company_letter_content: data?.guest_employee_letter[data?.guest_employee_letter?.length - 1]?.employee_letter_content ,
              selectedEmailTemplate: data?.guest_employee_email[data?.guest_employee_email?.length - 1]?.mail_template_id,
              // mailTemplateTitle: data?.guest_employee_email[data?.guest_employee_email?.length - 1]?. ,
              mailSubject: data?.guest_employee_email[data?.guest_employee_email?.length - 1]?.email_subject ,
              mailBody: data?.guest_employee_email[data?.guest_employee_email?.length - 1]?.employee_mail_content ,
              // required_letters: temp,
              // letter_rows: pdfPages,
              // email_template: emails,
              // save_as_draft: data?.guest_employee_personal?.save_as_draft,
              shareSalary: false,
              shareCtc : false,
              loadingInfo: false,
              // employee_id: this.state.employee_id

           }, () => {
            this.getEmailTemplateList();
            this.getLetterTemplateList();
            this.GetLetterHeadsList();
           });

          
          // this.getSalaryHeadList();
          
          
        }
        else {
          this.setState({ guest_employee_data: false, loadingInfo: false });
          // Swal.fire({
          //   title: `<strong>${success === true ? 'Success' : 'Failed'}</strong>`,
          //   text: response.data.message,
          //   icon: success === true ? 'success' : 'error',
          //   showConfirmButton:true,
          //   showCancelButton: true,
          //   allowOutsideClick:false,
          // })
          // .then((result)=>{
          //   console.log("Success False =======>>>>>>",result);
          //   if(result.isConfirmed){
          //     this.getGuestEmployeeInfo();
          //   }
          // })
        }
      })
      .catch(function (error) {
        this.setState({ loadingInfo: false });
        console.error('error', error)
      })
  }


removeDataParamFromUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete('data');
  window.history.replaceState({}, document.title, url.toString());
}

getSalaryHeadList = async () => {
  const { apiURL, apiHeaderJSON } = this.context
  const headers = apiHeaderJSON
  axios
    .get(`${apiURL}Payrolls/GetSalaryHeadsForOnboarding`, {
      params: {
        limit: 1000,
        page: 1
      },
      headers
    })
    .then(response => {
      let data = response.data
      // console.log(response?.data)
      if (response.data.success === true) {
        // let headRows = data?.data.filter(val => {
        //     return {
        //       value: val?.company_salary_head_id,
        //       label: val?.company_salary_head
        //     }
        // })
        const headRows = data?.data?.map(val => {
          return {
            value: val?.company_salary_head_id,
            label: val?.company_salary_head
          }
        })
        this.setState({ fixedHeads: headRows })
      } else {
      }
    })
    .catch(function (error) {
      console.error('error', error)
    })
}
  
  getEmailTemplateList = async () => {
    const { apiURL, apiHeaderJSON } = this.context
    const headers = apiHeaderJSON
    axios
      .get(`${apiURL}MailMaster/GetMailTemplateList`, {
        params: {
          limit: 999 || this.state.email_limit,
          page: 1 || this.state.email_page
        },
        headers
      })
      .then(response => {
        const data = response.data
        // console.log(response?.data)
        if (response.data.success === true) {
          let mail_list = [];
          if(this.state.selectedEmailTemplate && this.state.guest_employee_id && data?.response?.data?.length>0){
            mail_list =  data?.response?.data?.map((item,idx) => {
                if(this.state.selectedEmailTemplate === item?.mail_template_id){
                  this.setState({ emailIndex: idx });
                }
                if(this.state.selectedEmailTemplate === item?.mail_template_id){
                  return {
                    ...item,
                    mail_body: this.state.mailBody, 
                  }
                }
                return item;
            });
          }
          else {
            mail_list = data?.response?.data;
          }
          const email_opt =  data?.response?.data?.map((item,idx) => {
            return { value: item?.mail_template_id, label: item?.mail_template_title, index: idx };
          });
          console.log('email_opt',email_opt);
            this.setState({ 
              email_Options: email_opt,
              email_rows: mail_list,
              email_next: data?.response?.next ?? false,
              email_prev: data?.response?.prev ?? false,
              email_page: data?.response?.page ? data?.response?.page : 1,
              email_total_records: data?.response?.total_records ? data?.response?.total_records : 0,
              email_total_pages: data?.response?.total_pages ? data?.response?.total_pages : 0,
              loadingList: false,
             })
        } else {
        }
      })
      .catch(function (error) {
        console.error('error', error)
      })
  }
  getLetterTemplateList = async () => {
    const { apiURL, apiHeaderJSON } = this.context
    const headers = apiHeaderJSON
    axios
      .get(`${apiURL}Employees/GetCompanyLettersList`, {
        params: {
          limit: 999 || this.state.letter_limit,
          page: 1 || this.state.letter_page
        },
        headers
      })
      .then(response => {
        const data = response.data;
        // console.log(data)
        if (response.data.success === true) {
          let letter_list = [];
          if(this.state.selectedLetterTemplate && this.state.guest_employee_id && data.data?.length>0){
            letter_list = data.data?.map((item,idx) => {
                if(this.state.selectedLetterTemplate === item?.company_letter_id){
                  this.setState({ letterIndex: idx });
                }
                if (item.company_letter_id === this.state.selectedLetterTemplate) {
                  return {
                      ...item,
                      company_letter_content: this.state.company_letter_content
                  };
                }
                return item;
            });
          }
          else{
            letter_list = data.data;
          }
          const letter_opt = data.data?.map((item, idx) => {
          return { value: item?.company_letter_id, label: item?.company_letter_title, index: idx }
          });
          // console.log('letter_list',letter_list);
          this.setState({
            letter_Options: letter_opt,
            letter_rows: letter_list,
            letter_next: data.next||false,
            letter_prev: data.prev||false,
            letter_page: data.page|| 1,
            letter_total_records: data.total_records,
            letter_total_pages: data.total_pages,
            loadingList: false,
          });
        }
      })
      .catch(function (error) {
        console.error('error', error)
      })
  }
  getSignatoryTemplateList = ()=>{
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetSignatures`, {
        params: { limit: 100, page: 1, keyword: null },
        headers,
      })
      .then((response) => {
        var data = response.data;
        // console.log("GetSignatures",data);
        if (response.data.success === true) {
          const rows= data?.data?.map((val,idx)=>{
            return (
              {value: val?.signatory_id,
                  label:val?.signatory_name,
                  url:val?.signatory_signature_file_url,
                }
            )
          });
          // console.log("GetSignatures rows",rows);
          this.setState({
            signatoryRows: rows,
            selectedSignatoryTemplate:rows[0],
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  }
  getInfo = (idx) => {
    // const { apiURL, apiHeaderJSON } = this.context
    // const headers = apiHeaderJSON
    // axios
    //   .get(`${apiURL}MailMaster/GetMailTemplate?mail_template_id=${id}`, {
    //     headers
    //   })
    //   .then(response => {
    //     const { success, result } = response.data
    //     console.log(response?.data)
    //     if (success === true) {
    //       this.setState({
    //         infoLoading:false,
    //         isEmailModal: `${idx}`,
    //         mailTemplateTitle: result[0]?.mail_template_title,
    //         mailSubject: result[0]?.mail_subject,
    //         mailBody: JSON.parse(result[0]?.mail_body)
    //       })
    //     } else {
    //     }
    //   })
    this.setState({
      infoLoading:false,
      isEmailModal: `${idx}`,
      mailTemplateTitle: this.state.email_rows[idx]?.mail_template_title,
      mailSubject: this.state.email_rows[idx]?.mail_subject,
      mailBody: this.state.email_rows[idx]?.mail_body
    })
  }
  GetLetterHeadsList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetLetterHeads`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            company_letter_head: data.data.map((row) => ({
              value: row.company_letter_head_id,
              label: row.company_letter_head_name,
              markings: row.markings,
              letterhead_url: row.letterhead_url,
            })),
          }));
        }
      });
  };
  handleSelectOption = (e) => {
    const errorsList = { ...this.state.errors };
    delete errorsList.company_letter_head;

    this.setState(
      {
        markings: e.markings,
        company_letter_head_id:e.value,
        letterhead_url: e.letterhead_url,
        errors: errorsList,
      },
      (prevState) => { }
    );
  };

  GetLetterInfo=(idx)=>{
    this.setState({ 
      company_letter_title: this.state.letter_rows[idx]?.company_letter_title,
      company_letter_head_id: this.state.letter_rows[idx]?.company_letter_head_id,
      company_letter_content: this.state.letter_rows[idx]?.company_letter_content,
      markings: this.state.letter_rows[idx]?.markings || "0,0,0,0",
      letterhead_url: this.state.letter_rows[idx]?.letterhead_url || null,
      isLetterModal: `${idx}`
    });
  }
  GenerateSalaryStuctureTableHTML = (salary_data) => {
    // Start building the HTML table as a string
    let tableHTML = `
      <table style="border: 1px solid black; border-collapse: collapse; width: 90%; text-align: left; margin: 20px 0;">
        <tr>
          <th colspan="3" style="
                border: 1px solid black;
                padding: 4px;
                white-space: nowrap;
                text-align: center;
                font-size: 14px;
                font-weight: bold;
                text-transform: uppercase;
                background-color: #f4f4f4;
            ">
            ANNEXURE
          </th>
        </tr>
        <tr> 
            <th style="border: 1px solid black; padding: 4px; white-space: nowrap;">Salary Head</th>
            <th style="border: 1px solid black; padding: 4px; white-space: nowrap;">Monthly (INR)</th>
            <th style="border: 1px solid black; padding: 4px; white-space: nowrap;">Annual (INR)</th>
        </tr>
    `;
  
    // Add table rows dynamically
    salary_data.forEach(item => {
      tableHTML += `
        <tr>
            <td style="border: 1px solid black; padding: 8px;">${item?.company_salary_head}</td>
            <td style="border: 1px solid black; padding: 8px;">${Math.round(item?.company_salary_head_value || 0)}</td>
            <td style="border: 1px solid black; padding: 8px;">${Math.round((item?.company_salary_head_value || 0) * 12)}</td>
        </tr>
      `;
    });
  
    // Close the table
    tableHTML += `</table>`;
  
    // Wrap the table in a parent div
    let parent_div = `
      <div style="display: flex; justify-content: center; align-items: center; margin-top: 5px;">
        ${tableHTML}
      </div>
    `;
  
    return parent_div;
  };
  templatePreview=(templateType)=>{
    let designationLabel;
    let departmentLabel;
    let gradeLabel;
    let locationLabel;
    this.state.Designation?.forEach((val)=>{
      if(this.state.designation_id == val?.value){
        designationLabel=val?.label;
      }
    });
    this.state.Department?.forEach((val)=>{
      if(this.state.department_id == val?.value){
        departmentLabel=val?.label;
      }
    });
    this.state.Grade?.forEach((val)=>{
      if(this.state.grade_id == val?.value){
        gradeLabel=val?.label;
      }
    });
    this.state.Location?.forEach((val)=>{
      if(this.state.location_id == val?.value){
        locationLabel = val?.label;
      }
    });

   
    
    const replaceCheatCodeList=[
      {cheat_code:"##current_date##", value: formatDateWithTime()?.split(" ")[0] },
      // {cheat_code:"##offer_letter_link##", value: formatDateWithTime()?.split(" ")[0] },
      // {cheat_code:"##employee_title##", value: this.state.Title },
      {cheat_code:"##employee_name##", value: `${this.state.Title}. ${this.state.employee_name}` },
      {cheat_code:"##employee_address##", value: this.state.employee_address },
      {cheat_code:"##department_title##", value: departmentLabel },
      {cheat_code:"##designation_title##", value: designationLabel },
      {cheat_code:"##grade_title##", value: gradeLabel },
      {cheat_code:"##location_title##", value: locationLabel },
      {cheat_code:"##signature_image##", value: `<img src='${this.state.selectedSignatoryTemplate?.url}' style="width: 160px;" />` },
      {cheat_code:"##employee_joining_date##", value: formatDateWithTime(this.state.employee_joining_date)?.split(" ")[0] },
      {cheat_code:"##salary_amount##", value: this.state.allowances?.length>0? this.state.allowances
        ?.reduce(
          (total, allowance) =>
            total +
            parseFloat(
              allowance.company_salary_head_value
            ),
          0
        ):"" },
      // {cheat_code:"##ctc_structure##", value: this.state.allowances?.length>0 ? this.GenerateSalaryStuctureTableHTML(this.state.allowances):"" },
    ];
    
    if(templateType === "letter"){
      let letter=this.previewTemplate(this.state.company_letter_content,replaceCheatCodeList);
      // letter= this.removeUndefinedAndNull(letter);
      this.setState({letter_preview:letter});
    }
    if(templateType === "email"){
      let email=this.previewTemplate(this.state.mailBody,replaceCheatCodeList);
      // email= this.removeUndefinedAndNull(email);
      this.setState({email_preview:email});
    }
  }
  // removeUndefinedAndNull(inputString) {
  //   if (typeof inputString !== "string") {
  //     throw new Error("Invalid input: inputString must be a string.");
  //   }
  
  //   // Replace all occurrences of 'undefined' or 'null' in the string
  //   return inputString.replace(/\b(undefined|null)\b/g, "").trim();
  // }
  // previewTemplate = (inputString, cheatCodeArray) => {
  //   if (!inputString || !cheatCodeArray || !Array.isArray(cheatCodeArray)) {
  //     throw new Error("Invalid input: Provide a valid string and cheatCodeArray");
  //   }
  
  //   return cheatCodeArray.reduce((updatedString, { cheat_code, value }) => {
  //     if (cheat_code && value !== undefined && value !== null) {
  //       const regex = new RegExp(cheat_code, "g");
  //       return updatedString.replace(regex, value);
  //     }
  //     return updatedString;
  //   }, inputString);
  // };

  previewTemplate = (inputString, cheatCodeArray) => {
    if (!inputString || !cheatCodeArray || !Array.isArray(cheatCodeArray)) {
      throw new Error("Invalid input: Provide a valid string and cheatCodeArray");
    }
  
    return cheatCodeArray.reduce((updatedString, { cheat_code, value }) => {
      if (cheat_code && value) {
        const regex = new RegExp(cheat_code, "g");
        return updatedString.replace(regex, value);
      }
      return updatedString;
    }, inputString);
  };

  addPageBreak = () => {
    const editor = this.editorInstance;

    if (editor) {
      editor.model.change((writer) => {
        const selection = editor.model.document.selection;
        const position = selection.getFirstPosition();

        // Insert the page break as raw HTML
        writer.insertText("<!--PAGEBREAK-->", position);
      });

      // Update the state with the new content
      const updatedContent = editor.getData();
      this.setState({ company_letter_content: updatedContent });
    }
  };

  
  // renderPages(company_letter_content, letterhead_url, markings) {
  //     const pageHeight = 297;
  //     const marginTop = parseInt(markings.split(",")[0] || 0, 10);
  //     const marginBottom = parseInt(markings.split(",")[1] || 0, 10);
  //     const marginLeft = parseInt(markings.split(",")[3] || 0, 10);
  //     const marginRight = parseInt(markings.split(",")[2] || 0, 10);
  //     const contentHeight = pageHeight - (marginTop + marginBottom);
  //     const maxOverflow = contentHeight + 3; // Allowable overflow threshold
    
  //     const tempDiv = document.createElement("div");
  //     tempDiv.style.position = "absolute";
  //     tempDiv.style.width = "210mm";
  //     tempDiv.style.visibility = "hidden";
  //     tempDiv.style.fontSize = "14px";
  //     tempDiv.innerHTML = this.sanitizeHtmlContent(company_letter_content);
    
  //     document.body.appendChild(tempDiv);
    
  //     const pages = [];
  //     let currentPage = "";
  //     let totalHeight = 0;
  //     let prevContent = "";
  //     let prevHeight = 0;
    
  //     Array.from(tempDiv.childNodes).forEach((node) => {
  //       const clone = node.cloneNode(true);
  //       tempDiv.innerHTML = "";
  //       tempDiv.appendChild(clone);
    
  //       const computedStyle = window.getComputedStyle(tempDiv);
  //     const marginPaddingHeight = 
  //         parseFloat(computedStyle.marginTop) + 
  //         parseFloat(computedStyle.marginBottom) + 
  //         parseFloat(computedStyle.paddingTop) + 
  //         parseFloat(computedStyle.paddingBottom);
  
  //         const nodeHeight = (tempDiv.scrollHeight + marginPaddingHeight) / 3.77953;
  //         const projectedHeight = totalHeight + nodeHeight;
  
  //         if (projectedHeight <= contentHeight) {
  //           prevContent = currentPage;
  //           prevHeight = totalHeight;
  //           currentPage += node.outerHTML;
  //           totalHeight = projectedHeight;
  //         } else if (projectedHeight <= maxOverflow) {
  //           prevContent = currentPage;
  //           prevHeight = totalHeight;
  //           currentPage += node.outerHTML;
  //           totalHeight = projectedHeight;
  //         } else {
  //         // Overflow too large, use previous content
  //         console.log("Overflow detected, breaking page:", node.outerHTML, "Height:", nodeHeight);
  //         console.log("prevHeight, projectedHeight,contentHeight",prevHeight,projectedHeight,contentHeight);
  //         if (prevHeight > 0) {
  //           pages.push(prevContent); // Add previous content as a page
  //           currentPage = node.outerHTML; // Start new page with current node
  //           totalHeight = nodeHeight; // Reset height for new page
  //           prevContent = "";
  //           prevHeight = 0;
  //         } else {
  //           console.log("Overflow detected, breaking page:", node.outerHTML, "Height:", nodeHeight);
  //           console.log("prevHeight, projectedHeight,contentHeight",prevHeight,projectedHeight,contentHeight);
  //           // If no previous content, force add the current node to a new page
  //           pages.push(currentPage);
  //           currentPage = node.outerHTML;
  //           totalHeight = nodeHeight;
  //         }
  //       }
  //     });
    
  //     if (currentPage) {
  //       pages.push(currentPage); // Add any remaining content as a page
  //     }
    
  //     document.body.removeChild(tempDiv);
    
  //     return pages.map((pageContent, index) => (
  //       <div
  //         key={index}
  //         className="bubble-editor"
  //         style={{
  //           position: "relative",
  //           height: `${pageHeight}mm`,
  //           border: "1px solid #F3F3F9",
  //         }}
  //       >
  //         {letterhead_url && (
  //           <img
  //             src={letterhead_url}
  //             alt="Letterhead"
  //             style={{ position: "absolute", width: "100%", height: "297mm" }}
  //           />
  //         )}
  //         <div
  //           dangerouslySetInnerHTML={{ __html: pageContent }}
  //           style={{
  //             position: "relative",
  //             margin: `${marginTop}mm ${marginRight}mm ${marginBottom}mm ${marginLeft}mm`,
  //             boxSizing: "border-box",
  //             wordWrap: "break-word",
  //             height: `${contentHeight}mm`,
  //           }}
  //         />
  //       </div>
  //     ));
    
  // }
  
  // renderPages(company_letter_content, letterhead_url, markings) {
  //   const pageHeight = 297;
  //   const marginTop = parseInt(markings.split(",")[0] || 0, 10);
  //   const marginBottom = parseInt(markings.split(",")[1] || 0, 10);
  //   const marginLeft = parseInt(markings.split(",")[3] || 0, 10);
  //   const marginRight = parseInt(markings.split(",")[2] || 0, 10);
  //   // const content= company_letter_content.replace(/(&nbsp;)+/g, ' ');
  //   const contentHeight = pageHeight - (marginTop + marginBottom);
  //   console.log("contentHeight",contentHeight);
  //   const tempDiv = document.createElement("div");
  //   tempDiv.style.position = "absolute";
  //   tempDiv.style.width = "210mm";
  //   tempDiv.style.visibility = "hidden";
  //   tempDiv.style.fontSize = "14px";
  //   tempDiv.innerHTML = this.sanitizeHtmlContent(company_letter_content);

  //   document.body.appendChild(tempDiv);

  //   const pages = [];
  //   let currentPage = "";
  //   let totalHeight = 0;
  //   let prevContent="";
  //   Array.from(tempDiv.childNodes).forEach((node) => {
  //     const clone = node.cloneNode(true);
  //     tempDiv.innerHTML = "";
  //     tempDiv.appendChild(clone);

  //     const nodeHeight = tempDiv.scrollHeight / 3.77953;
  //     totalHeight += nodeHeight;
      
  //     // console.log("totalHeight , contentHeight",totalHeight , contentHeight);
  //     if (totalHeight <= contentHeight) {
  //       prevContent=currentPage;
  //       currentPage += node.outerHTML;
  //     }
  //     else if(totalHeight >= contentHeight && totalHeight <= contentHeight+4){
  //       pages.push(prevContent);
  //       currentPage += prevContent;
  //       totalHeight = nodeHeight;
  //     } else {
  //       console.log("totalHeight , contentHeight",totalHeight , contentHeight);
  //       console.log("totalHeight <= contentHeight",totalHeight > contentHeight);
  //       pages.push(currentPage);
  //       currentPage = node.outerHTML;
  //       totalHeight = nodeHeight;
  //     }
  //   });

  //   if (currentPage) pages.push(currentPage);

  //   document.body.removeChild(tempDiv);

  //   console.log("pages",pages);

  //   // this.setState({ pdfPages:pages });

  //   return pages.map((pageContent, index) => (
  //     <div
  //       key={index}
  //       className="bubble-editor"
  //       style={{
  //         position: "relative",
  //         // width: "210mm",
  //         height: `${pageHeight}mm`,
  //         // marginTop: `${marginTop}mm`,
  //         // marginBottom: `${marginBottom}mm`,
  //         border: "1px solid #F3F3F9",
  //       }}
  //     >
  //       {letterhead_url && (
  //         <img
  //           src={letterhead_url}
  //           alt="Letterhead"
  //           style={{ position: "absolute", width: "100%", height: "297mm" }}
  //         />
  //       )}
  //       <div
  //         dangerouslySetInnerHTML={{ __html: pageContent }}
  //         style={{
  //           position: "relative",
  //           margin: `${marginTop}mm ${marginRight}mm ${marginBottom}mm ${marginLeft}mm`,
  //           boxSizing: "border-box",
  //           // overflow: "hidden",
  //           wordWrap: "break-word",
  //           height: `${contentHeight}mm`,
  //         }}
  //       />
  //     </div>
  //   ));
  // }
  // renderPages(company_letter_content, letterhead_url, markings) {
  //   const pageHeight = 297;
  //   const marginTop = parseInt(markings.split(",")[0] || 0, 10);
  //   const marginBottom = parseInt(markings.split(",")[1] || 0, 10);
  //   const marginLeft = parseInt(markings.split(",")[3] || 0, 10);
  //   const marginRight = parseInt(markings.split(",")[2] || 0, 10);

  //   const contentHeight = pageHeight - (marginTop + marginBottom);
  //   console.log("contentHeight",contentHeight);
  //   const tempDiv = document.createElement("div");
  //   tempDiv.style.position = "absolute";
  //   tempDiv.style.width = "210mm";
  //   tempDiv.style.visibility = "hidden";
  //   tempDiv.style.fontSize = "14px";
  //   tempDiv.innerHTML = company_letter_content;

  //   document.body.appendChild(tempDiv);

  //   const pages = [];
  //   let currentPage = "";
  //   let totalHeight = 0;

  //   Array.from(tempDiv.childNodes).forEach((node) => {
  //     const clone = node.cloneNode(true);
  //     tempDiv.innerHTML = "";
  //     tempDiv.appendChild(clone);

  //     const nodeHeight = tempDiv.scrollHeight / 3.77953;
  //     totalHeight += nodeHeight;
      
  //     console.log("totalHeight , contentHeight",totalHeight , contentHeight);
  //     if (totalHeight <= contentHeight) {
  //       currentPage += this.sanitizeHtmlContent(node.outerHTML);
  //     } else {
  //       console.log("totalHeight , contentHeight",totalHeight , contentHeight);
  //       console.log("totalHeight <= contentHeight",totalHeight + 15 > contentHeight);
  //       let sanitizedContent = currentPage;
  //       pages.push(sanitizedContent);
  //       currentPage = node.outerHTML;
  //       totalHeight = nodeHeight;
  //     }
  //   });

  //   if (currentPage) pages.push(currentPage);

  //   document.body.removeChild(tempDiv);

  //   console.log("pages",pages);

  //   // this.setState({ pdfPages:pages });

  //   return pages.map((pageContent, index) => (
  //     <div
  //       key={index}
  //       className="bubble-editor"
  //       style={{
  //         position: "relative",
  //         // width: "210mm",
  //         height: `${pageHeight}mm`,
  //         // marginTop: `${marginTop}mm`,
  //         // marginBottom: `${marginBottom}mm`,
  //         border: "1px solid #F3F3F9",
  //       }}
  //     >
  //       {letterhead_url && (
  //         <img
  //           src={letterhead_url}
  //           alt="Letterhead"
  //           style={{ position: "absolute", width: "100%", height: "297mm" }}
  //         />
  //       )}
  //       <div
  //         dangerouslySetInnerHTML={{ __html: pageContent }}
  //         style={{
  //           position: "relative",
  //           margin: `${marginTop}mm ${marginRight}mm ${marginBottom}mm ${marginLeft}mm`,
  //           boxSizing: "border-box",
  //           // overflow: "hidden",
  //           wordWrap: "break-word",
  //           height: `${contentHeight}mm`,
  //         }}
  //       />
  //     </div>
  //   ));
  // }


  createPages(company_letter_content, letterhead_url, markings) {
    // const { company_letter_content, letterhead_url, markings } = this.state;
    const pageHeight = 297;
    const marginTop = parseInt(markings.split(",")[0] || 0, 10);
    const marginBottom = parseInt(markings.split(",")[1] || 0, 10);
    // const marginLeft = parseInt(markings.split(",")[3] || 0, 10);
    // const marginRight = parseInt(markings.split(",")[2] || 0, 10);

    const contentHeight = pageHeight - marginTop - marginBottom;

    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.width = "210mm";
    tempDiv.style.visibility = "hidden";
    tempDiv.style.fontSize = "14px";
    tempDiv.innerHTML = company_letter_content;

    document.body.appendChild(tempDiv);

    const pages = [];
    let currentPage = "";
    let totalHeight = 0;

    Array.from(tempDiv.childNodes).forEach((node) => {
      const clone = node.cloneNode(true);
      tempDiv.innerHTML = "";
      tempDiv.appendChild(clone);

      const nodeHeight = tempDiv.scrollHeight / 3.77953;
      totalHeight += nodeHeight;

      if (totalHeight <= contentHeight) {
        currentPage += node.outerHTML;
      } else {
        pages.push(currentPage);
        currentPage = node.outerHTML;
        totalHeight = nodeHeight;
      }
    });

    if (currentPage) pages.push(currentPage);

    document.body.removeChild(tempDiv);

    // console.log("pages",pages);

    return pages || [];
  }

  handleEditorChange = (event, editor) => {
    // const value = event.target.value;

    // Clear the previous timeout if the user is still typing
    if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
    }

    // Set a new timeout to call the function after 1 second
    this.debounceTimer = setTimeout(() => {
        const company_letter_content = editor.getData();
        // Clear the error for the company_letter_content field
        const errorsList = { ...this.state.errors };
        delete errorsList.company_letter_content;

        this.setState({ 
          company_letter_content:company_letter_content,
          errors: errorsList, // Update errors object
        });
    }, 1000);
};
handleEditorEmailChange = (event, editor) => {
    // const value = event.target.value;

    // Clear the previous timeout if the user is still typing
    if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
    }

    // Set a new timeout to call the function after 1 second
    this.debounceTimer = setTimeout(() => {
        const mailBody = editor.getData();
        // Clear the error for the mailBody field
        const errorsList = { ...this.state.errors };
        delete errorsList.mailBody;

        this.setState({ 
          mailBody:mailBody,
          errors: errorsList, // Update errors object
        });
    }, 1000);
};

handleLetter=()=>{
  const temp = [...this.state.letter_rows]; // Create a shallow copy of the array

    const index = parseInt(this.state.isLetterModal); // Index of the element to update
    if (index >= 0 && index < temp.length) {
        // Update the specific element at the given index
        temp[index] = {
            ...temp[index],
            // company_letter_head_id: this.state.company_letter_head_id,
            // company_letter_title: this.state.company_letter_title,
            company_letter_content: this.state.company_letter_content
        };
    }

    // Debugging: Log the updated value for verification
    // console.log('Updated element:', temp[index]);

    // Update the state with the modified array
    this.setState({ letter_rows: temp, letterEdit: false }, () =>{
        // console.log('Updated letter_rows:', this.state.letter_rows)
    });
};

handleInputChange = (e) => {
  const { name, value } = e.target;

  this.setState((prevState) => ({
    [name]: value,
    errors: {
      ...prevState.errors,
      [name]: '',
    },
  }));
};

handleSelectChange = (name, selectedOption) => {
  this.setState((prevState) => ({
    [name]: selectedOption.value,
    errors: {
      ...prevState.errors,
      [name]: '',
    },
  }));
};

  handleSelect (event) {
    // console.log(event.target.value);
    this.setState({
      employee_gender: event.target.value
    })
  }

  handleInputCheck = e => {
    var index = this.state.required_documents.indexOf(e.target.value)
    var arr = this.state.required_documents
    if (e.target.checked === true) {
      arr.push(e.target.value)
      this.setState({ required_documents: arr }, prevState => {})
    } else {
      arr.splice(index, 1)
      this.setState({ required_documents: arr }, prevState => {})
    }
  }

  handleRadioChange = (name, value) => {

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  GetListEmployeeDocumentType = () => {
    const { apiURL, apiHeaderJSON } = this.context
    const headers = apiHeaderJSON
    axios
      .get(`${apiURL}Employees/GetCompanyEmployeeDocumentType`, { headers })
      .then(response => {
        var data = response.data
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            loadingList: false
          })
        } else {
          this.setState({ loadingList: false })
        }
      })
  }
  getStateAndDesignation = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Payrolls/GetStatesAndDesignation`,
      { headers })
      .then((response) => {
        const { success } = response.data;
        // console.log(response?.data);
        if (success === true) {

          // let rows1 = response?.data?.response?.states.map((val) => {
          //   return { value: val?.state_id, label: val?.state_title }
          // });
          this.setState((prevState) => ({
            state_options: response?.data?.response?.states?.map((row) => ({
              value: row.state_id,
              label: row.state_title,
            })),
          }));
        }
      });
  }
  handleInputCheckLetter = e => {
    var index = this.state.required_letters.indexOf(e.target.value)
    var arr = this.state.required_letters
    if (e.target.checked === true) {
      arr.push(e.target.value)
      this.setState({ required_letters: arr }, prevState => {})
    } else {
      arr.splice(index, 1)
      this.setState({ required_letters: arr }, prevState => {})
    }
  }

  // GetCompanyLetters = () => {
  //   const { apiURL, apiHeaderJSON } = this.context
  //   const headers = apiHeaderJSON
  //   axios
  //     .get(`${apiURL}Masters/GetCompanyLettersList`, { headers })
  //     .then(response => {
  //       var data = response.data
  //       if (response.data.success === true) {
  //         this.setState({
  //           letter_rows: data.data,
  //           loadingList: false
  //         })
  //       } else {
  //         this.setState({ loadingList: false })
  //       }
  //     })
  // }
  GetDesignationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context
    const headers = apiHeaderJSON
    axios.get(`${apiURL}Employees/GetMasters`, { headers }).then(response => {
      var data = response.data.data.designation
      if (response.data.success === true) {
        this.setState(prevState => ({
          Designation: data.map(row => ({
            value: row.designation_id,
            label: row.designation_title
          }))
        }))
      }
    })
  }
  handleDesignationChange = selectedOption => {
    this.setState({
      designation_id: selectedOption.value
    })
  }
  handleDepartmentChange = selectedOption => {
    this.setState({
      department_id: selectedOption.value
    })
  }

  handleGradeChange = selectedOption => {
    this.setState({
      grade_id: selectedOption.value
    })
  }

  handleLocationChange = selectedOption => {
    this.setState({
      location_id: selectedOption.value
    })
  }
  handleShareCtcChange = (event) => {
    this.setState({ shareCtc: event.target.checked });
  };
  handleShareSalaryChange = event => {
    this.setState({
      shareSalary: event.target.checked
    })
  }
  GetGradeMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context
    const headers = apiHeaderJSON
    axios.get(`${apiURL}Employees/GetMasters`, { headers }).then(response => {
      var data = response.data.data.grades
      if (response.data.success === true) {
        this.setState(prevState => ({
          Grade: data.map(row => ({
            value: row.grade_id,
            label: row.grade_title
          }))
        }))
      }
    })
  }

  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context
    const headers = apiHeaderJSON
    axios.get(`${apiURL}Employees/GetMasters`, { headers }).then(response => {
      var data = response.data.data.department
      if (response.data.success === true) {
        this.setState(prevState => ({
          Department: data.map(row => ({
            value: row.department_id,
            label: row.department_title
          }))
        }))
      }
    })
  }

  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context
    const headers = apiHeaderJSON
    axios.get(`${apiURL}Employees/GetMasters`, { headers }).then(response => {
      var data = response.data.data.location
      if (response.data.success === true) {
        this.setState(prevState => ({
          Location: data.map(row => ({
            value: row.location_id,
            label: row.location_title
          }))
        }))
      }
    })
  }
  GetEmployeesTypeList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetEmployeeTypeList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            employee_type_row: data.data.map((row) => ({
              value: row.company_employee_type_id,
              label: row.company_employee_type
            }))
          }));
        }
      });
  }

  GetEmployeesCategoryList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetEmployeeCategoryList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            employee_category_row: data.data.map((row) => ({
              value: row.company_employee_category_id,
              label: row.company_employee_category
            }))
          }));
        }
      });
  }

  GetSalaryHeadList = () => {
    const { apiURL, apiHeaderJSON } = this.context
    const headers = apiHeaderJSON
    axios
      .get(`${apiURL}Masters/GetSalaryHeadList`, { headers })
      .then(response => {
        var data = response.data
        if (response.data.success === true) {
          this.setState({
            salary_heads_rows: data.data.map(row => ({
              value: row.company_salary_head_id,
              label: row.company_salary_head,
              amount: row.company_default_value
            }))
          })
        }
      })
  }

  GetSalaryStatutoryList = () => {
    const { apiURL, apiHeaderJSON } = this.context
    const headers = apiHeaderJSON
    axios
      .get(`${apiURL}Masters/GetSalaryStatutoryList`, { headers })
      .then(response => {
        var data = response.data
        if (response.data.success === true) {
          this.setState({
            company_salary_statutory_rows: data.data.map(row => ({
              value: row.company_salary_statutory_id,
              label: row.company_salary_statutory_title,
              company_salary_statutory_ids: row.company_salary_statutory_ids,
              company_salary_statutory_employee_contribution:
                row.company_salary_statutory_employee_contribution,
              company_salary_statutory_employer_contribution:
                row.company_salary_statutory_employer_contribution,
              company_salary_statutory_calculate_upto:
                row.company_salary_statutory_calculate_upto
            }))
          })
        }
      })
  }

  handleSubmit = () => {
    
    const { apiURL, apiHeaderJSON } = this.context
    const headers = apiHeaderJSON
    const gross = this.state.allowances
      .reduce((total, allowance) => total + parseFloat(allowance.amount), 0);

      const letters= this.state.letter_rows.filter((val)=>{
        if(this.state.selectedLetterTemplate == val?.company_letter_id){
          return {...val};
        }
      });
      const emails= this.state.email_rows.filter((val)=>{
        if(this.state.selectedEmailTemplate == val?.mail_template_id){
          return val;
        }
      });

      console.log("letters ==================>>>>>>>>>>>>>>>",letters);
      console.log("this.state.selectedLetterTemplate ==================>>>>>>>>>>>>>>>",this.state.selectedLetterTemplate);
      
      const pdfPages= createPages(letters[0]?.company_letter_content,letters[0]?.letterhead_url,letters[0]?.markings)
      let temp= [{...letters[0], letter_rows:pdfPages}]
      // console.log("temp",temp);
      // console.log("letter",letters);
      // console.log("pdfPage",pdfPages);
      // console.log(` this.state.selectedSignatoryTemplate`, this.state.selectedSignatoryTemplate?.value);
    let formData = {
      employeeDetails:{
      reference_code:this.state.referenceCode,
      employee_title: this.state.Title,
      employee_name: this.state.employee_name,
      employee_mobile_number: this.state.employee_mobile_number,
      employee_email_address: this.state.employee_email_address,
      employee_gender: this.state.employee_gender,
      date_of_birth: this.state.Date_of_birth,
      is_contract_employee: this.state.is_contract_employee,
      employee_from_date: this.state.From_date,
      employee_to_date: this.state.To_date,
      location_id: this.state.location_id,
      department_id: this.state.department_id,
      designation_id: this.state.designation_id,
      grade_id: this.state.grade_id,
      employee_joining_date: this.state.employee_joining_date,
      employee_address: this.state.employee_address,
      state_id: this.state.state_id,
      employee_type: this.state.company_employee_type_id,
      employee_category: this.state.company_employee_category_id,
      },
       effective_date: this.state.effective_date,
      date: currentDateAndTime(),
      signatory_id: this.state.selectedSignatoryTemplate?.value || "",
      employeeSalaryDetails: this.state.allowances,
      required_letters: temp,
      // letter_rows: pdfPages,
      email_template: emails
      }
    if(this.state.guest_employee_id){
      formData.guest_employee_id = this.state.guest_employee_id;
    }
    if(this.state.save_as_draft){
      formData.save_as_draft= "1";
    }
    if(this.state.shareSalary){
      formData.shareSalary= this.state.shareSalary;
    }
    if(this.state.shareSalary){
      formData.shareSalary= this.state.shareSalary;
    }
    if(this.state.shareCtc){
      formData.shareCtc = this.state.shareCtc;
    }
    if (this.state.employee_id !== 0) {
      formData.employee_id = this.state.employee_id
    }
    // console.log("SentOfferLetter", formData);
    console.log("SentOfferLetter formData ====>>>",formData);
    Swal.fire({
      title: 'Please wait...',
      text: 'Processing your request',
      icon: 'info',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      }
    })
    axios
      .post(`${apiURL}Employees/SentOfferLetter`, formData, { headers })
      .then(response => {
        Swal.close();
        const { success } = response.data
        if (success === true) {
          this.removeDataParamFromUrl();
          this.setState({
            guest_employee_id: 0,
            reference_code:"",
            Title: 'Mr.',
            employee_gender: 'Male',
            Date_of_birth: '',
            employee_name: "",
            employee_mobile_number: "",
            employee_email_address: "",
            date_of_birth: "",
            is_contract_employee: "",
            From_date: "",
            To_date: "",
            employee_from_date: "",
            employee_to_date: "",
            location_id: "",
            department_id: "",
            designation_id: "",
            grade_id: "",
            employee_joining_date: "",
            employee_address: "",
            allowances:[],
            selectedEmailTemplate:"",
            selectedLetterTemplate:"",
            shareSalary:"",
            required_letters:"",
            email_template:"",
            company_employee_type_id:"",
            company_employee_category_id:"",
            effective_date:"",
            save_as_draft:false,
            // pdfPages:"",
          })

          this.setState({ loadingList: true }, prevState => {
            // this.getList();
            this.getEmailTemplateList();
            this.getLetterTemplateList();
            this.getSignatoryTemplateList();
            this.GetLetterHeadsList();
            this.GetSalaryHeadList();
            // this.GetCompanyLetters();
            this.GetSalaryStatutoryList();
            this.GetListEmployeeDocumentType();
            this.GetDesignationMasters();
            this.GetGradeMasters();
            this.GetDepartmentMasters();
            this.GetLocationMasters();
          })
          Swal.fire({
            title: `<strong>${
              response.data.success === true ? 'Success' : 'Failed'
            }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? 'success' : 'error',
            showConfirmButton:true,
            allowOutsideClick:false,
          });
        } else {
          Swal.close()
          Swal.fire({
            title: `<strong>${
              response.data.success === true ? 'Success' : 'Failed'
            }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? 'success' : 'error',
            showConfirmButton:true,
            allowOutsideClick:false,
          })
          this.setState({ loadingList: true, save_as_draft:false }, prevState => {
            // this.GetSalaryHeadList()
            // this.GetCompanyLetters()
            // this.GetSalaryStatutoryList()
            // this.GetListEmployeeDocumentType()
            // this.GetDesignationMasters()
            // this.GetGradeMasters()
            // this.GetDepartmentMasters()
            // this.GetLocationMasters()
          })
        }
      }).catch((errors)=>{
        console.error(errors);
        this.setState({ loadingList: false, save_as_draft:false });
      })
  }

  handleNewOffer = () => {
  Swal.fire({
    title: "Are you sure?",
    text: `You want to discard this letter and create new new offer letter!`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: `Yes`,
    allowOutsideClick: false,
  }).then((result) => {
    if (result.isConfirmed) {
      this.removeDataParamFromUrl();
      this.setState({
        guest_employee_id: 0,
        reference_code:"",
        Title: 'Mr.',
        employee_gender: 'Male',
        Date_of_birth: '',
        employee_name: "",
        employee_mobile_number: "",
        employee_email_address: "",
        date_of_birth: "",
        is_contract_employee: "",
        employee_from_date: "",
        employee_to_date: "",
        location_id: "",
        department_id: "",
        designation_id: "",
        grade_id: "",
        employee_joining_date: "",
        employee_address: "",
        allowances:[],
        selectedEmailTemplate:"",
        selectedLetterTemplate:"",
        shareSalary:"",
        required_letters:"",
        email_template:"",
        company_employee_type_id:"",
        company_employee_category_id:"",
        effective_date:"",
        save_as_draft:false,
        // pdfPages:"",
      }, () => {
        this.getEmailTemplateList();
        this.getLetterTemplateList();
      })
    }
  });
  }

  handleTypeChange = selectedOption => {
    // Extract the necessary data from the selected option
    const { value: company_salary_head_id } = selectedOption

    // Update the state with the selected company_salary_head_id
    this.setState({
      selectedSalaryType: selectedOption,
      company_salary_head_id,
      // company_salary_head_id: selectedOption.company_salary_head_id,
      amount: selectedOption.amount
    })
  }

  handleAmountChange = e => {
    this.setState({ amount: e.target.value })
  }

  handleAddAllowance = () => {
    const { selectedSalaryType, amount, allowances, company_salary_head_id ,effective_date} =
      this.state

    // Validate if selectedSalaryType or amount is missing
    // console.log("selectedSalaryType, amount ===>",selectedSalaryType, amount);
    if (!selectedSalaryType || !amount) {
      Swal.fire({
        icon: 'warning',
        title: '<strong>Oops..</strong>',
        text: `Please select a ${!selectedSalaryType && !amount? "salary type and enter an amount":!selectedSalaryType? "salary type": !amount? "enter an amount":""}!`,
        showConfirmButton: true,
        allowOutsideClick: false
      }).then(() => {
        // Set state after "OK" button is clicked
        this.setState({ amount:false });
      });
      return
    }

    // Check for duplicate company_salary_head_id
    const isDuplicate = allowances.some(
      allowance => allowance.company_salary_head_id === company_salary_head_id
    )

    if (isDuplicate) {
      Swal.fire({
        icon: 'error',
        title: '<strong>Error</strong>',
        text: 'This salary head has already been added!',
        showConfirmButton: true,
        allowOutsideClick: false
      }).then(() => {
        // Set state after "OK" button is clicked
        this.setState({ amount:false });
      });
      return
    }

    // Proceed to add the new allowance
    const newAllowance = {
      company_salary_head_id: company_salary_head_id,
      company_salary_head: selectedSalaryType.label,
      company_salary_head_value: parseFloat(amount)
    }

    this.setState(
      {
        allowances: [...allowances, newAllowance],
        selectedSalaryType: null,
        amount: ''
      },
      () => {
        // console.log("allowances",this.state.allowances);
        this.handleCTCStatutory() // Call the next function if required
      }
    )
  }

  handleDeleteAllowance = index => {
    const { allowances } = this.state
    const updatedAllowances = allowances.filter((_, i) => i !== index)
    this.setState({ allowances: updatedAllowances })
  }

  // company_salary_statutory //
  handleStatutoryTypeChange = selectedOption => {
    this.setState({
      statutoryType: selectedOption,
      employee_contribution:
        selectedOption.company_salary_statutory_employer_contribution,
      employer_contribution:
        selectedOption.company_salary_statutory_employee_contribution
    })
  }

  handleEmployeeContributionChange = e => {
    this.setState({ employee_contribution: e.target.value })
  }

  handleEmployerContributionChange = e => {
    this.setState({ employer_contribution: e.target.value })
  }

  handleAddStatutory = () => {
    const {
      statutoryType,
      employee_contribution,
      employer_contribution,
      statutoryList
    } = this.state
    // console.log('statutoryType, statutoryList', statutoryType, statutoryList)

    // Validate required fields
    if (!statutoryType || !employee_contribution || !employer_contribution) {
      Swal.fire({
        icon: 'warning',
        title: '<strong>Oops..</strong>',
        text: 'Please enter all fields!',
        showConfirmButton: true,
        allowOutsideClick: false
      })
      return
    }

    // Check for duplicate company_salary_statutory_id
    const isDuplicate = statutoryList.some(
      item => item.company_salary_statutory_id == statutoryType.value
    )

    if (isDuplicate) {
      Swal.fire({
        icon: 'error',
        title: '<strong>Duplicate Entry</strong>',
        text: 'This statutory type already exists in the list!',
        showConfirmButton: true,
        allowOutsideClick: false
      })
      return
    }

    // Calculate total percentage and salary
    const sat_total_perc =
      Number(parseFloat(employee_contribution)) +
      Number(parseFloat(employer_contribution))

    const total_salary_for_calc = this.GetTotalSalaryBasedOnFarmula(
      statutoryType.company_salary_statutory_ids,
      statutoryType.company_salary_statutory_calculate_upto,
      sat_total_perc
    )

    const total = (total_salary_for_calc.total / 100) * sat_total_perc

    // Create new statutory entry
    const newStatutory = {
      company_salary_statutory_id: statutoryType.value,
      type: statutoryType.label,
      employee_contribution: parseFloat(employee_contribution),
      employer_contribution: parseFloat(employer_contribution),
      total_persent: sat_total_perc,
      total: total,
      formula: total_salary_for_calc.formula
    }

    // Update state
    this.setState(
      {
        statutoryList: [...statutoryList, newStatutory],
        statutoryType: null,
        employee_contribution: '',
        employer_contribution: ''
      },
      () => {
        this.handleCTCStatutory()
      }
    )
  }

  handleCTCStatutory = () => {
    const { allowances, statutoryList } = this.state

    const totalAllowances = allowances.reduce(
      (total, allowance) => total + parseFloat(allowance.company_salary_head_value),
      0
    )
    const totalStatutory = statutoryList.reduce(
      (total, statutory) => total + parseFloat(statutory.total),
      0
    )
    // console.log("allowances, statutoryList, totalAllowances",allowances, statutoryList, totalAllowances);
    
    const ctc = totalAllowances;
    this.setState({
      ctc: ctc
    })
  }

  GetTotalSalaryBasedOnFarmula = (ids, calculate_upto, percentage) => {
    var idsArr = ids.split(',')
    // return 10000;
    var heads = []
    var total = 0
    for (var i = 0; i < idsArr.length; i++) {
      for (var x = 0; x < this.state.allowances.length; x++) {
        if (
          Number(this.state.allowances[x].company_salary_head_id) ===
          Number(idsArr[i])
        ) {
          total += Number(this.state.allowances[x].amount)
          heads.push(this.state.allowances[x].type)
        }
      }
    }
    var formula = '(' + heads.join(' + ') + ') / 100 X %' + percentage
    if (total > calculate_upto) {
      return calculate_upto
    }
    return { total: total, formula: formula }
  }

  handleDeleteStatutory = index => {
    const { statutoryList } = this.state
    const updatedStatutoryList = statutoryList.filter((_, i) => i !== index)
    this.setState({ statutoryList: updatedStatutoryList });
  }

  handleSelectTitle = selectedOption => {
    this.setState({ Title: selectedOption.value })
  }
  handleSelectSignatory = selectedOption => {
    // console.log("selectedOption",selectedOption);
    this.setState({ selectedSignatoryTemplate: selectedOption });
  }
  // company_salary_statutory //

  handlePreviousTab = tabId => {
    const prevTab = document.getElementById(tabId);
    if (prevTab) {
      prevTab.click()
    }
  }

  handleNextTab = ( tabId,pageNum) => {
    const errorsList = this.validateForm(pageNum)
    console.error('handleNextTab 1', errorsList)
    if (Object.keys(errorsList).length > 0) {
      // console.log('handleNextTab 2', errorsList);
      this.setState({ errors: errorsList })
      return
    }
    const nextTab = document.getElementById(tabId)
    if (nextTab) {
      nextTab.click()
    }
  }
  handleCopyClick = (code) => {
    copy(code);
    toast.success(`Code Has Been Copied! ${code}`, { autoClose: 1500 });
  };

  handleEmail = () => {
    const temp = [...this.state.email_rows]; // Create a shallow copy of the array

    const index = parseInt(this.state.isEmailModal); // Index of the element to update
    if (index >= 0 && index < temp.length) {
        // Update the specific element at the given index
        temp[index] = {
            ...temp[index],
            mail_body: this.state.mailBody,
            mail_template_title: this.state.mailTemplateTitle,
            mail_subject: this.state.mailSubject,
        };
    }

    // Debugging: Log the updated value for verification
    // console.log('Updated element:', temp[index]);

    // Update the state with the modified array
    this.setState({ email_rows: temp, emailEdit: false }, () =>{
        // console.log('Updated email_rows:', this.state.email_rows)
    });
};


 validateSubmit=(pageNum)=>{

  const errorsList = this.validateForm(pageNum)
  console.error('validateSubmit error', errorsList);
  if (Object.keys(errorsList).length > 0) {
    if(errorsList?.selectedLetterTemplate){
      Swal.fire({
        title: `<strong>Failed</strong>`,
        text: errorsList?.selectedLetterTemplate,
        icon: 'error',
        showConfirmButton:true,
        allowOutsideClick:false,
      })
    }
    this.setState({ errors: errorsList })
    return
  }


  
// const gross = this.state.allowances.reduce((total, allowance) => total + parseFloat(allowance.amount), 0)

// "employeeDetails":{
// "employee_name":"Yuno",
// "employee_title":"Mr",
// "employee_mobile_number":"4556345656",
// "employee_email_address":"nitin.pr2002@gmail.com",
// "employee_address":"mumbai",
// "login_id":"",
// "login_password":"",
// "designation_id":"168",
// "grade_id":"52",
// "department_id":"74",
// "location_id":"83",
// "employee_joining_date":"2024-09-08",
// "date_of_birth":"2000-09-01",
// "is_contract_employee":"1",
// "employee_from_date":"2024-09-08",
// "employee_to_date":"2025-04-08",
// "employee_gender":"Male",
// "employee_permanent_address":""
// },
// "employeeSalaryDetails":[
//     {
//         "company_salary_head_value":15000,
//         "company_salary_head":"Fixed Basic",
//         "company_salary_head_id":37
//     },
//      {
//         "company_salary_head_value":1500,
//         "company_salary_head":"Fixed HRA",
//         "company_salary_head_id":38
//     }
// ],
// "required_letters":"41",
// "email_template":3

// const letters= this.state.letter_rows.filter((val)=>{
//   if(this.state.selectedLetterTemplate == val?.company_letter_id){
//     return val;
//   }
// });
// const emails= this.state.email_rows.filter((val)=>{
//   if(this.state.selectedEmailTemplate == val?.mail_template_id){
//     return val;
//   }
// });
// console.log(
//  {
//   reference_code:this.state.referenceCode,
//   employee_title: this.state.Title,
//   employee_name: this.state.employee_name,
//   employee_mobile_number: this.state.employee_mobile_number,
//   employee_email_address: this.state.employee_email_address,
//   employee_gender: this.state.employee_gender,
//   date_of_birth: this.state.Date_of_birth,
//   is_contract_employee: this.state.is_contract_employee,
//   employee_from_date: this.state.From_date,
//   employee_to_date: this.state.To_date,
//   location_id: this.state.location_id,
//   department_id: this.state.department_id,
//   designation_id: this.state.designation_id,
//   grade_id: this.state.grade_id,
//   employee_joining_date: this.state.employee_joining_date,
//   employee_address: this.state.employee_address,
//   employeeSalaryDetails: this.state.allowances,
//   required_letters: letters,
//   email_template: emails
//   }
// );

  Swal.fire({
    title: "Are you sure?",
    text: `You want to ${this.state.save_as_draft ? "save as draft" : "send" } the offer letter!`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: `Yes, ${this.state.save_as_draft ? "Save" : "Send"}!`,
    allowOutsideClick: false,
  }).then((result) => {
    if (result.isConfirmed) {
      this.handleSubmit();
    }
  });
}
// generatePDF = () => {
//   const letterContainer = document.getElementById("letter-content");

//   if (!letterContainer) {
//     console.error("Letter content not found!");
//     return;
//   }

//   // Ensure all images are loaded before capturing the HTML
//   const images = letterContainer.getElementsByTagName("img");
//   let imagesLoaded = 0;

//   const checkImagesLoaded = () => {
//     imagesLoaded++;
//     if (imagesLoaded === images.length) {
//       // All images are loaded, now capture the content
//       html2canvas(letterContainer, { scale: 2, useCORS: true }).then((canvas) => {
//         const imgData = canvas.toDataURL("image/png");
//         const doc = new jsPDF("p", "mm", "a4");
//         const imgWidth = 210; // A4 width in mm
//         const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

//         doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
//         doc.save("Offer_Letter.pdf");
//       });
//     }
//   };

//   // If there are images, wait for them to load
//   if (images.length > 0) {
//     for (let img of images) {
//       img.crossOrigin = "anonymous"; // Ensure CORS images load
//       img.onload = checkImagesLoaded;
//       img.onerror = checkImagesLoaded;
//     }
//   } else {
//     // No images, proceed directly
//     html2canvas(letterContainer, { scale: 2, useCORS: true }).then((canvas) => {
//       const imgData = canvas.toDataURL("image/png");
//       const doc = new jsPDF("p", "mm", "a4");
//       const imgWidth = 210;
//       const imgHeight = (canvas.height * imgWidth) / canvas.width;

//       doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
//       doc.save("Offer_Letter.pdf");
//     });
//   }
// };

  validateForm = pageNum => {
    const errors = []
    if (pageNum === 1) {
      if (!this.state.Title) {
        errors.title = 'Title is required!'
      }
      if (!this.state.employee_name) {
        errors.employee_name = 'Name is required!'
      }
      if (!this.state.employee_mobile_number) {
        errors.employee_mobile_number = 'Mobile number is required!'
      }
      if (!this.state.employee_email_address) {
        errors.employee_email_address = 'Mobile number is required!'
      }
      if (!this.state.employee_gender) {
        errors.employee_gender = 'Gender is required!'
      }
      if (!this.state.Date_of_birth) {
        errors.Date_of_birth = 'DOB is required!'
      }
      if (!this.state.is_contract_employee) {
        errors.is_contract_employee = 'This is required!'
      }
      if (this.state.is_contract_employee=="1" && (!this.state.From_date)) {
        errors.From_date = 'From date is required!'
      }
      if (this.state.is_contract_employee=="1" && (!this.state.To_date)) {
        errors.To_date = 'To date is required!'
      }
      if (!this.state.state_id) {
        errors.state_id = 'State is required!'
      }
      if (!this.state.location_id) {
        errors.location_id = 'Location is required!'
      }
      if (!this.state.department_id) {
        errors.department_id = 'Department is required!'
      }
      if (!this.state.designation_id) {
        errors.designation_id = 'Designation is required!'
      }
      if (!this.state.grade_id) {
        errors.grade_id = 'Grade is required!'
      }
      if (!this.state.company_employee_type_id) {
        errors.company_employee_type_id = 'Employee Type is required!'
      }
      if (!this.state.company_employee_category_id) {
        errors.company_employee_category_id = 'Employee Category is required!'
      }
      if (!this.state.employee_joining_date) {
        errors.employee_joining_date = 'Joining Date is required!'
      }
      if (!this.state.employee_address) {
        errors.employee_address = 'Address is required!'
      }
      // console.log("this.state.Date_of_birth && this.state.employee_joining_date1",this.state.Date_of_birth , this.state.employee_joining_date)
    if(this.state.Date_of_birth && this.state.employee_joining_date){
      // console.log("this.state.Date_of_birth && this.state.employee_joining_date2",this.state.Date_of_birth , this.state.employee_joining_date)
      const age=calculateAge(this.state.Date_of_birth,this.state.employee_joining_date);
      // console.log("Age",age);
      if(age<18){
        errors.Date_of_birth="Candidate age cannot be less than 18 Yrs.";
        errors.employee_joining_date ="Candidate age cannot be below 18 Yrs. on joining date";
      }
    }
    }
    if (pageNum === 2){
      if (this.state.allowances.length===0 || !this.state.allowances) {
        errors.allowances = 'Salary Details are required!';
      }
    }
    if (pageNum === 2){
      // if (this.state.effective_date.length===0 || !this.state.effective_date) {
      //   errors.effective_date = 'effective date is required!';
      // }
    }
    if (pageNum === 3){
      if (!this.state.selectedLetterTemplate) {
        errors.selectedLetterTemplate = 'Letter template is required!';
      }
    }
    if (pageNum === 4){
      if (!this.state.selectedLetterTemplate) {
        errors.selectedLetterTemplate = 'Letter template is required!';
      }
      if (!this.state.selectedEmailTemplate) {
        errors.selectedEmailTemplate = 'Email Template is required!';
      }
      const letters= this.state.letter_rows.filter((val)=>{
        if(this.state.selectedLetterTemplate == val?.company_letter_id){
          return {...val};
        }
      });
      if (letters?.length === 0) {
        errors.selectedLetterTemplate = 'Letter Template is not found!';
      }
      const emails= this.state.email_rows.filter((val)=>{
        if(this.state.selectedEmailTemplate == val?.mail_template_id){
          return val;
        }
      });
      if (emails?.length === 0) {
        errors.selectedEmailTemplate = 'Email Template is not found!';
      }
    }
    return errors
  }
  handleShareSalaryMeChange = event => {
    this.setState({ shareSalary: event.target.checked })
  }
  handleShareCtcMeChange = event => {
    this.setState({ shareCtc: event.target.checked })
  }

  handleDocumentMeChange = event => {
    this.setState({ documentMe: event.target.checked })
  }

  handlePrev = (list) => {
    if(list==="letter"){
      if (this.state.letter_prev === true) {
        this.setState(
          (prevState) => {
            return { letter_page: prevState.letter_page - 1 };
          },
          () => {
            this.getLetterTemplateList(); // This will log the updated state value
          }
        );
      }
    }
    if(list==="email"){
      if (this.state.email_prev === true) {
        this.setState(
          (prevState) => {
            return { email_page: prevState.email_page - 1 };
          },
          () => {
            this.getLetterTemplateList(); // This will log the updated state value
          }
        );
      }
    }
    
  };
  handleNext = (list) => {
    if(list==="letter"){
      if (this.state.letter_next === true) {
        this.setState(
          (prevState) => {
            return { page: prevState.letter_page + 1 };
          },
          () => {
            this.getLetterTemplateList(); // This will log the updated state value
          }
        );
      }
    }
    if(list==="email"){
      if (this.state.email_next === true) {
        this.setState(
          (prevState) => {
            return { page: prevState.email_page + 1 };
          },
          () => {
            this.getLetterTemplateList(); // This will log the updated state value
          }
        );
      }
    }
    
  };
  handleChange = (e,list) => {
    if(list==="letter"){
      this.setState(
        (prevState) => {
          return { letter_page: parseInt(e.target.value, 10) };
        },
        () => {
          this.getLetterTemplateList(); // This will log the updated state value
        }
      );
    }
    if(list==="email"){
      this.setState(
        (prevState) => {
          return { email_page: parseInt(e.target.value, 10) };
        },
        () => {
          this.getLetterTemplateList(); // This will log the updated state value
        }
      );
    }
    
  };

  render () {
    const { selectedSalaryType, amount, allowances} = this.state   
    return (
      <>
      {!this.state.loadingInfo ? (
        <div className='main-content'>
          <div className='page-content'>
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-xl-12'>
                  <div className='card mt-3'>
                    {/* <div style={{ width: "60%", margin: "auto" }}>
                        <div className=" position-relative alert alert-danger mt-3" role="alert">
                            This page is under development.
                        </div>
                    </div> */}
                    <div className='card-header d-flex justify-content-between align-items-center'>
                      <h4 className='card-title mb-0'>Guest Employee</h4>
                      <div className=''>
                        <SubmitButton  onClick={(e)=>{ 
                              this.handleNewOffer()
                          }}
                          disabled={!this.state.guest_employee_id} 
                          buttonName={'New'} icon={'ri-add-circle-line'} 
                          type='success' iconSide='left'
                        />
                        <NavLink className="btn btn-primary btn-label ms-2 waves-effect waves-light" 
                          to={`/DraftLetters`} onClick={this.removeDataParamFromUrl} accordion>
                            <i className={`ri-file-list-line label-icon align-middle fs-16`} />
                            <span className="flex-grow-1 me-2">Draft Letters</span>
                        </NavLink>
                      </div>
                      {/* <SubmitButton  onClick={(e)=>{ 
                            this.props.history.push('/DraftLetters')
                        }}
                        // disabled={!filter?.checkStatutoryType && !filter?.checkState} 
                        loadingMessage='Loading' buttonName={'Draft Letters'} icon={'ri-filter-3-fill'} 
                        type='primary' iconSide='left'
                      /> */}
                    </div>

                    <div className='card-body form-steps'>
                      <div className='vertical-navs-step'>
                        <div className='row gy-5'>
                          <div className='col-lg-3'>
                            <div className='nav flex-column custom-nav nav-pills' role='tablist' aria-orientation='vertical'>
                              {/* Candidate Details */}
                              <button className='nav-link active' id='v-pills-bill-info-tab' data-bs-toggle='pill' data-bs-target='#v-pills-bill-info' type='button' role='tab' aria-controls='v-pills-bill-info' aria-selected='true'>
                                <span className='step-title me-2'><i className='ri-close-circle-fill step-icon me-2' />Step 1</span>
                                Candidate
                              </button>
                              {/* Salary Details */}
                              <button className='nav-link' id='v-pills-bill-address-tab' data-bs-toggle='pill' data-bs-target='#v-pills-bill-address' type='button' role='tab' aria-controls='v-pills-bill-address' aria-selected='false'>
                                <span className='step-title me-2'><i className='ri-close-circle-fill step-icon me-2' />Step 2</span>
                                Salary Details
                              </button>
                              {/* <button
                                className="nav-link"
                                id="v-pills-payment-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#v-pills-payment"
                                type="button"
                                role="tab"
                                aria-controls="v-pills-payment"
                                aria-selected="false"
                              >
                                <span className="step-title me-2">
                                  <i className="ri-close-circle-fill step-icon me-2" />{" "}
                                  Step 3
                                </span>
                                Required Documents
                              </button> */}
                              {/* Letter Details */}
                              <button className='nav-link' id='v-pills-finish-tab' data-bs-toggle='pill' data-bs-target='#v-pills-finish' type='button' role='tab' aria-controls='v-pills-finish' aria-selected='false'>
                                <span className='step-title me-2'><i className='ri-close-circle-fill step-icon me-2' />Step 3</span>
                                Letter
                              </button>
                              {/* Email Details */}
                              <button className='nav-link' id='v-pills-email-tab' data-bs-toggle='pill' data-bs-target='#v-pills-email' type='button' role='tab' aria-controls='v-pills-email' aria-selected='false'>
                                <span className='step-title me-2'><i className='ri-close-circle-fill step-icon me-2' />Step 4</span>
                                Email Details
                              </button>
                            </div>
                          </div>
                          <div className='col-lg-9'>
                            <div className='px-lg-4'>
                              <div className='tab-content'>
                                {/* Candidate Details */}
                                <div className='tab-pane fade show active' id='v-pills-bill-info' role='tabpanel' aria-labelledby='v-pills-bill-info-tab'>
                                  <div>
                                    <h5>Candidate Details
                                      <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                      padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                      >*</span>
                                    </h5>
                                    <p className='text-muted'>Fill all information below</p>
                                  </div>
                                  <div>
                                    <div className='row g-3'>
                                      {/* Reference code */}
                                      <div className='col-sm-6'>
                                        <TextBox type='TextArea' id='referenceCode' name='referenceCode' label='Reference code'
                                        hint='Enter Reference code' value={this.state.referenceCode} change={this.handleInputChange}/>
                                      </div>
                                      {/* Title */}
                                      <div className='col-sm-6'>
                                        <label htmlFor='Title' className='form-label'>
                                          Title:
                                          <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                          padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                          >*</span>
                                        </label>
                                        <Select id='Title' name='Title'
                                          value={titleOptions.find( option => option.value === this.state.Title)}
                                          onChange={this.handleSelectTitle}
                                          options={titleOptions}
                                        />
                                        {this.state.errors.title && (<div className='text-danger'>{this.state.errors.title}</div>)}
                                      </div>
                                      {/* Candidate name */}
                                      <div className='col-6'>
                                        <TextBox type='text' id='employee_name' name='employee_name'
                                          label={ 
                                          <span>Candidate name:
                                            <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                            padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                            >*</span>
                                          </span>}
                                          hint='Enter Candidate name'
                                          value={this.state.employee_name}
                                          change={this.handleInputChange}
                                        />
                                        {this.state.errors.employee_name && (<div className='text-danger'>{this.state.errors.employee_name}</div>)}
                                      </div>
                                      {/* Mobile */}
                                      <div className='col-6'>
                                        <TextBox type='Number' id='employee_mobile_number' name='employee_mobile_number'
                                          label={
                                          <span>Mobile:
                                            <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                            padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                            >*</span>
                                          </span>}
                                          hint='Enter Mobile'
                                          value={this.state.employee_mobile_number}
                                          change={this.handleInputChange}
                                        />
                                        {this.state.errors.employee_mobile_number && (<div className='text-danger'>{this.state.errors.employee_mobile_number}</div>)}
                                      </div>
                                      {/* Personal E-mail */}
                                      <div className='col-6'>
                                        <TextBox type='email' id='employee_email_address' name='employee_email_address'
                                          label={
                                            <span>Personal E-mail:
                                              <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                              padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                              >*</span>
                                            </span>}
                                          hint='Enter E-mail'
                                          value={this.state.employee_email_address}
                                          change={this.handleInputChange}
                                        />
                                        {this.state.errors.employee_email_address && (<div className='text-danger'>{this.state.errors.employee_email_address}</div>)}
                                      </div>
                                      {/* Gender */}
                                      <div className='col-sm-6'>
                                        <label htmlFor='employee_gender' className='form-label'>
                                          Gender:
                                          <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                          padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                          >*</span>
                                        </label>
                                        <Select id='employee_gender' name='employee_gender'
                                          value={ this.state.employee_gender ? genderOptions.find( option => option.value === this.state.employee_gender ) : null}
                                          onChange={(selectedOption)=>this.handleSelectChange("employee_gender",selectedOption)}
                                          options={genderOptions}
                                        />
                                        {this.state.errors.employee_gender && (<div className='text-danger'>{this.state.errors.employee_gender}</div>)}
                                      </div>
                                      {/* Date of birth */}
                                      <div className='col-6'>
                                        <TextBox type='Date' id='Date_of_birth' name='Date_of_birth'
                                          label={
                                            <span>Date of birth:
                                              <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                              padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                              >*</span>
                                            </span>}
                                          hint=''
                                          value={this.state.Date_of_birth}
                                          change={this.handleInputChange}
                                        />
                                        {this.state.errors.Date_of_birth && (<div className='text-danger'>{this.state.errors.Date_of_birth}</div>)}
                                      </div>
                                      {/* Contract Employees */}
                                      <div className="col-md-6 mb-3">
                                        <label htmlFor="is_contract_employee" className="form-label">
                                          Contract Employees: (Yes-No)
                                        </label><br/>

                                        <div className="form-check form-check-inline" >
                                          <input type="radio" id="is_contract_employee1" name="is_contract_employee" value="1"
                                            checked={this.state.is_contract_employee == '1'}
                                            onChange={() => this.handleRadioChange('is_contract_employee', '1')}
                                            className={`form-check-input ${this.state.errors.is_contract_employee ? 'is-invalid' : ''}`}
                                          />
                                          <label htmlFor="is_contract_employee1" className="form-check-label">Yes</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                          <input type="radio" id="is_contract_employee0" name="is_contract_employee" value="0"
                                            checked={this.state.is_contract_employee == '0'}
                                            onChange={() => this.handleRadioChange('is_contract_employee', '0')}
                                            className={`form-check-input ${this.state.errors.is_contract_employee ? 'is-invalid' : ''}`}
                                          />
                                          <label htmlFor="is_contract_employee0" className="form-check-label">No</label>
                                        </div>
                                      </div>
                                      {/* From Date and To Date */}
                                      {this.state.is_contract_employee == '1' && <>
                                        <div className="col-md-6 mb-3">
                                          <label htmlFor="From_date" className="form-label"> From Date:
                                            <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                            padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                            >*</span>
                                          </label>
                                          <input type="date" id="From_date" name="From_date"
                                            value={this.state.From_date}
                                            onChange={this.handleInputChange}
                                            className={`form-control ${this.state.errors.From_date ? 'is-invalid' : ''}`}
                                          />
                                          {this.state.errors.From_date && <div className="text-danger">{this.state.errors.From_date}</div>}
                                        </div>
                                        {/* To Date */}
                                        <div className="col-md-6 mb-3">
                                          <label htmlFor="To_date" className="form-label"> To Date:
                                            <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                            padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                            >*</span>
                                          </label>
                                          <input type="date" id="To_date" name="To_date"
                                            value={this.state.To_date}
                                            onChange={this.handleInputChange}
                                            className={`form-control ${this.state.errors.To_date ? 'is-invalid' : ''}`}
                                          />
                                          {this.state.errors.To_date && <div className="text-danger">{this.state.errors.To_date}</div>}
                                        </div>
                                      </>}
                                      {/* Company State */}
                                      <div className="col-md-6 mb-3">
                                        <label htmlFor="state_id" className="form-label">Company State:
                                          <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                          padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                          >*</span>
                                        </label>
                                        <Select
                                          options={this.state.state_options}
                                          value={ this.state.state_id ? this.state.state_options.find(option => option.value == this.state.state_id) : null}
                                          onChange={(selectedOption) => this.handleSelectChange('state_id', selectedOption)}
                                          placeholder={`Select State`} 
                                          />
                                        {this.state.errors.state_id && <div className="text-danger">{this.state.errors.state_id}</div>}
                                      </div>
                                      {/* Company Location */}
                                      <div className='col-sm-6'>
                                        <label htmlFor='Location' className='form-label'>
                                          Company Location:
                                          <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                          padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                          >*</span>
                                        </label>
                                        <Select
                                          options={this.state.Location}
                                          onChange={this.handleLocationChange}
                                          value={ this.state.location_id ? this.state.Location.find(option => option.value == this.state.location_id) : null}
                                          hint={`Select Location`}
                                        />
                                        {this.state.errors.location_id && (<div className='text-danger'>{this.state.errors.location_id}</div>)}
                                      </div>
                                      {/* Department */}
                                      <div className='col-sm-6'>
                                        <label htmlFor='Department' className='form-label'>
                                          Department:
                                          <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                          padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                          >*</span>
                                        </label>
                                        <Select
                                          options={this.state.Department}
                                          onChange={this.handleDepartmentChange}
                                          value={ this.state.department_id ? this.state.Department.find(option => option.value == this.state.department_id) : null}
                                          hint={`Select Department`}
                                        />
                                        {this.state.errors.department_id && (<div className='text-danger'>{this.state.errors.department_id}</div>)}
                                      </div>
                                      {/* Designation */}
                                      <div className='col-sm-6'>
                                        <label htmlFor='Designation' className='form-label'>
                                          Designation:
                                          <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                          padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                          >*</span>
                                        </label>
                                        <Select
                                          options={this.state.Designation}
                                          onChange={this.handleDesignationChange}
                                          value={this.state.designation_id ? this.state.Designation.find(option => option.value == this.state.designation_id) : null }
                                          hint={`Select Designation`}
                                        />
                                        {this.state.errors.designation_id && (<div className='text-danger'>{this.state.errors.designation_id}</div>)}
                                      </div>
                                      {/* Grade */}
                                      <div className='col-sm-6'>
                                        <label htmlFor='Grade' className='form-label'>
                                          Grade:
                                          <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                          padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                          >*</span>
                                        </label>
                                        <Select
                                          options={this.state.Grade}
                                          onChange={this.handleGradeChange}
                                          value={
                                            this.state.grade_id ? this.state.Grade.find(option => option.value == this.state.grade_id) : null}
                                          hint={`Select Grade`}
                                        />
                                        {this.state.errors.grade_id && (<div className='text-danger'>{this.state.errors.grade_id}</div>)}
                                      </div>
                                      {/* Employee Type */}
                                      <div className="col-md-6 mb-3">
                                        <label htmlFor="company_employee_type_id" className="form-label">
                                          Employee Type:
                                          <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                          padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                          >*</span>
                                        </label>
                                        <Select id="company_employee_type_id" name="company_employee_type_id"
                                          value={this.state.company_employee_type_id ? this.state.employee_type_row.find(option => option.value == this.state.company_employee_type_id) : null}
                                          onChange={(selectedOption) => this.handleSelectChange('company_employee_type_id', selectedOption)}
                                          options={this.state.employee_type_row}
                                          placeholder="Select employee type" 
                                          />
                                        {this.state.errors.company_employee_type_id && <div className="text-danger" >{this.state.errors.company_employee_type_id}</div>}
                                      </div>
                                      {/* Employee Category */}
                                      <div className="col-md-6 mb-3">
                                        <label htmlFor="company_employee_category_id" className="form-label">
                                          Employee Category:
                                          <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                          padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                          >*</span>
                                        </label>
                                        <Select id="company_employee_category_id" name="company_employee_category_id"
                                          value={this.state.company_employee_category_id ? this.state.employee_category_row.find(option => option.value == this.state.company_employee_category_id) : null}
                                          onChange={(selectedOption) => this.handleSelectChange('company_employee_category_id', selectedOption)}
                                          options={this.state.employee_category_row}
                                          placeholder="Select employee category" 
                                          />
                                        {this.state.errors.company_employee_category_id && <div className="text-danger" >{this.state.errors.company_employee_category_id}</div>}
                                      </div>
                                      {/* Joining Date */}
                                      <div className='col-6'>
                                        <TextBox type='Date' id='employee_joining_date' name='employee_joining_date'
                                          label={
                                            <span>Joining Date:
                                              <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                              padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                              >*</span>
                                            </span>}
                                          value={this.state.employee_joining_date}
                                          change={this.handleInputChange}
                                        />
                                        {this.state.errors.employee_joining_date && (<div className='text-danger'>{this.state.errors.employee_joining_date}</div>)}
                                      </div>
                                      {/* Employee Current Address */}
                                      <div className='col-6'>
                                        <TextArea type='text' id='employee_address' name='employee_address'
                                          label={
                                            <span>Employee Current Address:
                                              <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                              padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                              >*</span>
                                            </span>}
                                          hint='Enter Communication address'
                                          value={this.state.employee_address}
                                          change={this.handleInputChange}
                                        />
                                        {this.state.errors.employee_address && (<div className='text-danger'>{this.state.errors.employee_address}</div>)}
                                      </div>
                                    </div>
                                  </div>
                                  <div className='d-flex align-items-start gap-3 mt-4'>
                                    <button type='button' className='btn btn-primary btn-label right ms-auto nexttab '
                                      onClick={() => this.handleNextTab('v-pills-bill-address-tab',1)}
                                      data-nexttab='v-pills-bill-address-tab'
                                    >
                                      <i className='ri-arrow-right-line label-icon align-middle fs-16 ms-2' />
                                      Next
                                    </button>
                                  </div>
                                </div>
                                {/* Salary Details */}
                                <div className='tab-pane fade' id='v-pills-bill-address' role='tabpanel' aria-labelledby='v-pills-bill-address-tab'>
                                  <div>
                                    <div className='row g-3'>
                                      <h5>Salary Details
                                        <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                        padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                        >*</span>
                                      </h5>
                                      {/* <p className='text-muted my-0'>Fill all information below</p> */}
                                    {/* Salary Effective Date */}
                                    {/* <div className="col-md-3 mb-0">
                                      <label htmlFor="effective_date" className="form-label">
                                        Salary Effective Date:
                                        <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                        padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                        >*</span>
                                      </label>
                                      <input type="date" id="effective_date" name="effective_date"
                                        value={this.state.effective_date}
                                        onChange={this.handleInputChange}
                                        className={`form-control ${errors.effective_date ? 'is-invalid' : ''}`}
                                        placeholder="Select the effective date"
                                      />
                                      {errors.effective_date && <div className="invalid-feedback">{errors.effective_date}</div>}
                                    </div> */}
                                      <div>
                                        <p className='mb-2 h6'>Select Salary Type</p>
                                        <div style={{ gridTemplateColumns: '2fr 2fr 1fr' }} className='d-grid gap-3 mb-3 '>
                                          <div className='md-col-3'>
                                            <Select
                                              options={this.state.fixedHeads}
                                              onChange={this.handleTypeChange}
                                              value={selectedSalaryType}
                                            />
                                          </div>
                                          <div className='md-col-3'>
                                            <input type='number' id='cleave-numeral' className='form-control' placeholder='Enter Amount'
                                              value={amount}
                                              onChange={this.handleAmountChange}
                                            />
                                          </div>
                                          <div className='md-col-3'>
                                            <button type='button' className='btn btn-success btn-label waves-effect right waves-light'
                                            onClick={this.handleAddAllowance}>
                                              <i className='bx bx-add-to-queue label-icon align-middle fs-16 ms-2' />{' '}
                                              Add
                                            </button>
                                          </div>
                                        </div>
                                        <table className='table table-nowrap table-sm text-center' style={{ marginBottom: '50px' }}>
                                          <thead className='table-light '>
                                            <tr>
                                              <th scope='col'>Allowance Type</th>
                                              <th scope='col'>Amount</th>
                                              <th scope='col'>Action</th>
                                            </tr>
                                          </thead>
                                          {allowances?.length === 0 ? (
                                            <tbody>
                                              <tr>
                                                <td colSpan={12}>
                                                  <NoRecords />
                                                </td>
                                              </tr>
                                            </tbody>
                                          ) : (
                                            <tbody>
                                              {allowances.map(
                                                (allowance, index) => (
                                                  <tr key={index}>
                                                    <td>{allowance?.company_salary_head}</td>
                                                    <td>{allowance?.company_salary_head_value}</td>
                                                    <td>
                                                      <button type='button' className='btn btn-link text-danger fs-15'
                                                      onClick={() => this.handleDeleteAllowance(index)}>
                                                        <i className='ri-delete-bin-line' />
                                                      </button>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </tbody>
                                          )}
                                          <tfoot className='table-light'>
                                            <tr>
                                              <th scope='rowgroup' colSpan='1'>CTC</th>
                                              <th scope='rowgroup' colSpan='1'>
                                                {allowances?.length>0 && allowances ?.reduce( (total, allowance) => total + parseFloat( allowance.company_salary_head_value ), 0)}
                                              </th>
                                              <th scope='rowgroup' colSpan='1'></th>
                                            </tr>
                                          </tfoot>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='d-flex align-items-start gap-3 mt-4'>
                                    <button type='button' className='btn btn-light btn-label previestab'
                                    onClick={() => this.handlePreviousTab('v-pills-bill-info-tab')} data-previous='v-pills-bill-info-tab'>
                                      <i className='ri-arrow-left-line label-icon align-middle fs-16 me-2' />
                                      Back
                                    </button>
                                    <button type='button' className='btn btn-primary btn-label right ms-auto nexttab '
                                    onClick={() =>{ this.getSalaryHeadList(); this.handleNextTab('v-pills-finish-tab',2)}} data-nexttab='v-pills-finish-tab'>
                                      <i className='ri-arrow-right-line label-icon align-middle fs-16 ms-2' />
                                      Next
                                    </button>
                                  </div>
                                </div>
                                {/* Documents */}
                                {/* <div
                                  className='tab-pane fade'
                                  id='v-pills-payment'
                                  role='tabpanel'
                                  aria-labelledby='v-pills-payment-tab'
                                >
                                  <div>
                                    <h5>
                                      Required Documents{' '}
                                      <span
                                        style={{
                                          color: 'blue',
                                          borderRadius: '50%',
                                          background: '#f0f8ff',
                                          padding: '2px 6px',
                                          display: 'inline-block',
                                          textAlign: 'center',
                                          width: '20px',
                                          height: '20px',
                                          lineHeight: '20px'
                                        }}
                                      >
                                        *
                                      </span>
                                    </h5>
                                    <p className='text-muted'>
                                      Fill all information below
                                    </p>
                                  </div>

                                  <div className='card'>
                                    <div className='card-body'>
                                      <div className='d-flex align-items-center mb-4'>
                                        <h5 className='card-title flex-grow-1 mb-0'>
                                          Documents
                                        </h5>
                                        <div className='flex-shrink-0'>
                                          <input
                                            className='form-control d-none'
                                            type='file'
                                            id='formFile'
                                          />
                                        </div>
                                      </div>

                                      <div className='row'>
                                        <div className='col-lg-12'>
                                          <div className='table-responsive'>
                                            <table className='table table-borderless align-middle mb-0'>
                                              <thead className='table-light'>
                                                <tr>
                                                  <th scope='col' width='90%'>
                                                    Document
                                                  </th>

                                                  <th
                                                    scope='col'
                                                    width='10%'
                                                  ></th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {this.state.rows.map(row => {
                                                  return (
                                                    <tr
                                                      key={
                                                        row.employee_document_type_id
                                                      }
                                                    >
                                                      <td>
                                                        {
                                                          row.employee_document_type_title
                                                        }
                                                      </td>
                                                      <td className='d-flex justify-content-around'>
                                                        <input
                                                          className='form-check-input'
                                                          type='checkbox'
                                                          id='checkAll'
                                                          value={
                                                            row.employee_document_type_id
                                                          }
                                                          onChange={
                                                            this.handleInputCheck
                                                          }
                                                        />
                                                      </td>
                                                    </tr>
                                                  )
                                                })}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='d-flex align-items-start gap-3 mt-4'>
                                    <button
                                      type='button'
                                      className='btn btn-light btn-label previestab'
                                      onClick={() =>
                                        this.handlePreviousTab(
                                          'v-pills-bill-address-tab'
                                        )
                                      }
                                      data-previous='v-pills-bill-address-tab'
                                    >
                                      <i className='ri-arrow-left-line label-icon align-middle fs-16 me-2' />{' '}
                                      Back
                                    </button>
                                    <button
                                      type='button'
                                      className='btn btn-primary btn-label right ms-auto nexttab nexttab'
                                      onClick={() =>
                                        this.handleNextTab('v-pills-finish-tab')
                                      }
                                      data-nexttab='v-pills-finish-tab'
                                    >
                                      <i className='ri-arrow-right-line label-icon align-middle fs-16 ms-2' />
                                      Next
                                    </button>
                                  </div>
                                </div> */}
                                {/* Letter Details */}
                                <div className='tab-pane fade' id='v-pills-finish' role='tabpanel' aria-labelledby='v-pills-finish-tab'>
                                  <>
                                    <h5>Letter Details
                                      <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                      padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                      >*</span>
                                    </h5>
                                    <p className='text-muted'>Select Below letter template</p>
                                  </>
                                  <div className="row">
                                    <div className='col-sm-6'>
                                      <label htmlFor='selectedLetterTemplate' className='form-label'>
                                        Letters
                                        <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                        padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                        >*</span>:
                                      </label>
                                      <Select id='selectedLetterTemplate' name='selectedLetterTemplate'
                                        value={ this.state.selectedLetterTemplate ? this.state.letter_Options.find( option => option.value == this.state.selectedLetterTemplate ) : null}
                                        onChange={(selectedOption)=>{this.handleSelectChange("selectedLetterTemplate",selectedOption); this.setState({ letterIndex: selectedOption?.index })}}
                                        options={this.state.letter_Options}
                                        placeholder='Select Letter'
                                      />
                                      {this.state.errors.selectedLetterTemplate && (<div className='text-danger'>{this.state.errors.selectedLetterTemplate}</div>)}
                                    </div>
                                    <div className='col-md-3'>
                                        <div>
                                            <label className=' noWrap'>Review Letter:</label>
                                        </div>
                                        <SubmitButton onClick={(e)=>{ this.GetLetterInfo(this.state.letterIndex) }}
                                        disabled={!this.state.selectedLetterTemplate} 
                                        buttonName={'View'} icon={'ri-file-info-line'} 
                                        type='success' iconSide='left' />
                                    </div>
                                    {/* <table className={`table table-bordered table-hover`}>
                                      <thead className="table-light">
                                        <tr>
                                          <th>Select</th>
                                          <th>Sr.No.</th>
                                          <th width={`70%`}>Letter Lists</th>
                                          <th width={`10%`} className=' text-center'>
                                            Action
                                          </th>
                                          
                                        </tr>
                                      </thead>
                                      { Array.isArray(this.state.letter_rows) && this.state.letter_rows.length===0 ? 
                                        <tbody>
                                          <tr>
                                            <td colSpan={12}>
                                              <NoRecords />
                                            </td>
                                          </tr>
                                        </tbody> :
                                        <tbody> 
                                          {this.state.letter_rows.map((row,idx) => {
                                            return (
                                              <tr key={row?.company_letter_id}>
                                                <td >
                                                  <div className="d-flex justify-content-center align-items-center">
                                                    <input type="checkbox" className="form-check-input" checked={this.state.selectedLetterTemplate==row?.company_letter_id} onChange={() => this.setState({ letterIndex:idx, selectedLetterTemplate:row?.company_letter_id, errors:{...this.state.errors, selectedLetterTemplate:""} })} />
                                                  </div>
                                                </td>
                                                <td>{idx+1}</td>
                                                <td>{row?.company_letter_title}</td>
                                                <td><button onClick={() => this.setState({ infoLoading: true }, () => { this.GetLetterInfo(idx) })} className="btn-icon btn btn-sm btn-outline-success"> <i className="ri-file-info-line"></i> </button></td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>}
                                      <tfoot className="table-light">
                                        <tr>
                                          <th colSpan={7}>
                                            <div className="d-flex justify-content-between">
                                              <button disabled={ this.state.letter_prev === false && this.state.loadingList === false ? true : false }
                                                type="button"
                                                onClick={() => this.handlePrev("letter")}
                                                className={`btn btn-warning btn-label waves-effect waves-light`}
                                              >
                                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                Previous
                                              </button>
                                              <div className="col-md-4" style={{ display: "flex", alignItems: "center" }}>
                                                {
                                                  <small>
                                                    Total Records: {this.state.letter_total_records} |
                                                    Total Pages: {this.state.letter_total_pages} |
                                                    Current Page: {this.state.letter_page}
                                                  </small>
                                                }
                                              </div>
                                              <div className="col-md-2">
                                                <select className="form-select" onChange={(e) => this.handleChange(e,"letter")}>
                                                  {Array.from({ length: this.state.letter_total_pages },
                                                    (_, i) => (
                                                      <option selected={this.state.letter_page === i + 1} key={i} value={i + 1}>
                                                        Page {i + 1}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </div>
                                              <button disabled={ this.state.letter_next === false && this.state.loadingList === false ? true : false }
                                                type="button"
                                                onClick={() =>{ this.handleNext("letter")}}
                                                className={`btn btn-primary btn-label waves-effect right waves-light`}
                                              >
                                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                Next
                                              </button>
                                            </div>
                                          </th>
                                        </tr>
                                      </tfoot>
                                    </table> */}
                                  </div>
                                  {this.state.isLetterModal && (
                                    <div id="myModal" className="modal show" tabIndex={-1} style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} aria-labelledby="myModalLabel" aria-hidden="true">
                                      <div className="modal-dialog modal-lg">
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5 className="modal-title" id="myModalLabel">Letter Template</h5>
                                            <button className="btn-close" aria-label="Close"
                                              onClick={() => { this.setState({ isLetterModal: false, letterEdit:false, previewClicked:false}); }}
                                            ></button>
                                          </div>
                                          <div className="modal-body">
                                            <div className='mt-3'>
                                                  {!this.state.letterEdit?
                                                  <div>
                                                    <button type="button" className={` btn btn-warning btn-label mx-2`}
                                                      onClick={()=> this.setState({ letterEdit:true })}
                                                    >
                                                      Edit
                                                      <i className="ri-eye-line label-icon align-middle fs-16" />
                                                    </button>
                                                    <div className="card-body">
                                                      <h5 className=' py-1 px-4'>Letter Title: {this.state.letter_rows[parseInt(this.state.isLetterModal)]?.company_letter_title}</h5>
                                                      {/* <h5 className=' py-2 px-4'></h5> */}
                                                      {this.state.letter_rows[parseInt(this.state.isLetterModal)]?.company_letter_content && this.state.letter_rows[parseInt(this.state.isLetterModal)]?.letterhead_url ? renderPages(this.state.letter_rows[parseInt(this.state.isLetterModal)]?.company_letter_content, this.state.letter_rows[parseInt(this.state.isLetterModal)]?.letterhead_url,this.state.letter_rows[parseInt(this.state.isLetterModal)]?.markings) : <h4 className="text-muted">No Preview available.</h4>}
                                                    </div>
                                                  </div>:
                                                  <>
                                                    {
                                                      !this.state.previewClicked?
                                                      // editor 
                                                      <div>
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                          <button
                                                            type="button"
                                                            className={`${this.state.company_letter_content ? ('') : 'd-none'} btn btn-primary btn-label mx-2`}
                                                            onClick={()=> ( this.setState({ previewClicked:true }, ()=>{ this.templatePreview("letter") }))} // Add onClick handler for preview button
                                                          >
                                                            Preview
                                                            <i className="ri-eye-line label-icon align-middle fs-16" />
                                                          </button>                                                          
                                                          <button type="button" className="btn btn-primary waves-effect right waves-light btn-label" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
                                                            <i className="ri-code-s-slash-line label-icon align-middle fs-16" />{" "}
                                                            Placeholder Keys
                                                          </button>
                                                          </div>
                                                          <div className="offcanvas offcanvas-end" tabIndex={-1} id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                                                            <div className="offcanvas-header">
                                                                <h5 id="offcanvasRightLabel"> Placeholder Keys</h5>
                                                                <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"/>
                                                            </div> 
                                                            <div className="offcanvas-body">
                                                              <table class="table table-hover table-bordered border-primary table-nowrap">
                                                                <thead className="bg-primary text-light bg-gradient">
                                                                    <tr>
                                                                        <th scope="col">Names</th>
                                                                        <th scope="col">Code</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                  {
                                                                    offerLetterCheatCode?.map((val)=>{
                                                                      return (
                                                                        <tr>
                                                                            <td>{val?.name}</td>
                                                                            <td onClick={() => this.handleCopyClick(val?.code)} style={{ cursor: "pointer" }}>{val?.code}</td>
                                                                        </tr>
                                                                      )
                                                                    })
                                                                  }
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                          {/* <div
                                                            className="col-md-12"
                                                            style={{ marginBottom: "20px" }}
                                                          >
                                                            <label>Select Letter Head</label>
                                                            <div className="w-100">
                                                              <Select
                                                                options={this.state.company_letter_head}
                                                                value={this.state.company_letter_head.find(option => option.value === this.state.company_letter_head_id) || null}
                                                                onChange={this.handleSelectOption}
                                                                hint={`Select`}
                                                              />
                                                              {this.state.errors.company_letter_head && <div className="text-danger">{this.state.errors.company_letter_head}</div>}
                                                            </div>
                                                          </div> */}
                                                          {/* <div
                                                            className="col-md-12"
                                                            style={{ marginBottom: "20px" }}
                                                          >
                                                            <TextBox
                                                              type="text"
                                                              id="company_letter_title"
                                                              name="company_letter_title"
                                                              value={this.state.company_letter_title}
                                                              label="Letter Title "
                                                              hint="Enter Letter Title"
                                                              change={this.handleInputChange}
                                                            />
                                                            {this.state.errors.company_letter_title && <div className="text-danger">{this.state.errors.company_letter_title}</div>}
                                                          </div> */}
                                                          <div className='col-sm-6'>
                                                            <div className=' '>
                                                              <label htmlFor='Signatory' className='form-label'>
                                                                Signatory
                                                              </label>
                                                              <Select id='Signatory' name='Signatory'
                                                                value={this.state.signatoryRows.find( option => option.value === this.state.selectedSignatoryTemplate?.value )}
                                                                onChange={this.handleSelectSignatory}
                                                                options={this.state.signatoryRows}
                                                              />
                                                            </div>
                                                            {/* {this.state.errors.title && (
                                                              <div className='text-danger'>
                                                                {this.state.errors.title}
                                                              </div>
                                                            )} */}
                                                          </div>
                                                          <h5 className=' py-1 mt-3 '>Letter Title: {this.state.letter_rows[parseInt(this.state.isLetterModal)]?.company_letter_title}</h5>
                                                          <div className="col-md-12" style={{ marginBottom: "" }}>
                                                            <CKEditor
                                                              editor={ClassicEditor}
                                                              data={this.state.company_letter_content}
                                                              name={"company_letter_content"}
                                                              onChange={this.handleEditorChange}
                                                            />
                                                        </div>
                                                        
                                                      </div>:
                                                      // preview 
                                                      <div className="card-body">
                                                        <button type="button" className={`btn btn-warning btn-label mb-3 mx-2`}
                                                          onClick={()=> this.setState({ previewClicked:false })} // Add onClick handler for preview button
                                                        >
                                                          Editor
                                                          <i className="ri-eye-line label-icon align-middle fs-16" />
                                                        </button>
                                                        <h5 className=' py-1'>Letter Title: {this.state.letter_rows[parseInt(this.state.isLetterModal)]?.company_letter_title}</h5>
                                                        {this.state.company_letter_content && this.state.letterhead_url ? renderPages(this.state.letter_preview, this.state.letterhead_url,this.state.markings)
                                                        : <h4 className="text-muted">No Preview available.</h4>}
                                                      </div>
                                                    }
                                                    <div style={{ marginTop: '30px', marginLeft: 'Auto' }}>
                                                        <button style={{ marginRight:"10px" }} onClick={this.handleLetter} className={`btn btn-primary btn-label waves-effect right waves-light float-right`}>
                                                          <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />
                                                          Save
                                                        </button>
                                                        <button onClick={()=> this.setState({ letterEdit:false})} className={`btn btn-danger btn-label waves-effect right waves-light float-right`}>
                                                          <i className={`ri-save-line label-icon align-middle fs-16 ms-2`}/>
                                                          Cancel
                                                        </button>
                                                      </div>
                                                  </>
                                                  }
                                            </div>
                                          </div>
                                          <div className="modal-footer">
                                            <button
                                              onClick={() => { this.setState({ isLetterModal: false , letterEdit:false, previewClicked:false});}}
                                              className="btn btn-light"
                                            >
                                              Close
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {/* <div className='row'>
                                    {this.state.letter_rows.map(row => {
                                      return (
                                        <div
                                          className='col-md-4'
                                          key={row.company_letter_id}
                                        >
                                      
                                          <div className='card profile-project-card shadow-none profile-project-primary p-2'>
                                            <div
                                              style={{
                                                height: '150px',
                                                overflow: 'hidden'
                                              }}
                                            >
                                              <img
                                                className='card-img-top img-fluid'
                                                src={row.letterhead_url}
                                                alt='Letter Img ??'
                                              />
                                            </div>
                                            <div className='card-body'>
                                              <h4 className='card-title mb-2'>
                                                {row.company_letter_title}
                                              </h4>
                                            </div>
                                            <input
                                              className='form-check-input'
                                              type='checkbox'
                                              id='checkAll'
                                              value={row.company_letter_id}
                                              onChange={
                                                this.handleInputCheckLetter
                                              }
                                            />
                                          </div>
                                          
                                        </div>
                                      )
                                    })}
                                  </div> */}
                                  
                                  <div className=' row'>
                                    <div className='mb-3'>
                                      <div className='mt-3 mb-3' style={{ border: '1.5px solid #c7c7c7', width: '100%' }}></div>
                                      <div className='form-check' style={{ float: 'right', marginLeft:"10px"  }}>
                                        <input className='form-check-input' type='checkbox' value='' id='auth-remember-check1'
                                          checked={this.state.shareCtc}
                                          onChange={this.handleShareCtcChange}
                                        />
                                        <label className='form-check-label' htmlFor='auth-remember-check1'>Do You Want to Share CTC structure</label>
                                      </div>
                                      <div className='form-check' style={{ float: 'right',}}>
                                        <input className='form-check-input' type='checkbox' value='' id='auth-remember-check2'
                                          checked={this.state.shareSalary}
                                          onChange={this.handleShareSalaryChange}
                                        />
                                        <label className='form-check-label' htmlFor='auth-remember-check2'>Do You Want to Share CTC amount</label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className=' row'>
                                    <div className='d-flex align-items-start gap-3 mt-0'>
                                      <button type='button' className='btn btn-light btn-label previestab'
                                        onClick={() => this.handlePreviousTab('v-pills-bill-address-tab') }
                                        data-previous='v-pills-bill-address-tab'
                                      >
                                        <i className='ri-arrow-left-line label-icon align-middle fs-16 me-2' />{' '}
                                        Back
                                      </button>
                                      <button type='button' className='btn btn-primary btn-label right ms-auto nexttab '
                                        onClick={() => this.handleNextTab('v-pills-email-tab',3) } data-nexttab='v-pills-email-tab'>
                                        <i className='ri-arrow-right-line label-icon align-middle fs-16 ms-2' />
                                        Next
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                {/* Email Details */}
                                <div className='tab-pane fade' id='v-pills-email' role='tabpanel' aria-labelledby='v-pills-email-tab'>
                                  <div>
                                    <h5>Email Details
                                      <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                      padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                      >*</span>
                                    </h5>
                                    <p className='text-muted'>Fill all information below</p>
                                  </div>
                                  <div className='row'>
                                    <div className='col-sm-6'>
                                      <label htmlFor='selectedEmailTemplate' className='form-label'>
                                        Emails
                                        <span style={{ color: 'blue', marginLeft: '5px', borderRadius: '50%', background: '#f0f8ff',
                                        padding: '2px 6px', display: 'inline-block', textAlign: 'center', width: '20px', height: '20px', lineHeight: '20px'}}
                                        >*</span>:
                                      </label>
                                      <Select id='selectedEmailTemplate' name='selectedEmailTemplate'
                                        value={ this.state.selectedEmailTemplate ? this.state.email_Options.find( option => option.value == this.state.selectedEmailTemplate ) : null}
                                        onChange={(selectedOption)=>{this.handleSelectChange("selectedEmailTemplate",selectedOption); this.setState({ emailIndex: selectedOption?.index })}}
                                        options={this.state.email_Options}
                                        placeholder='Select Email'
                                      />
                                      {this.state.errors.selectedEmailTemplate && (<div className='text-danger'>{this.state.errors.selectedEmailTemplate}</div>)}
                                    </div>
                                    <div className='col-md-3'>
                                        <div>
                                            <label className=' noWrap'>Review Email:</label>
                                        </div>
                                        <SubmitButton onClick={(e)=>{ this.getInfo(this.state.emailIndex) }}
                                        disabled={!this.state.selectedEmailTemplate} 
                                        buttonName={'View'} icon={'ri-file-info-line'} 
                                        type='success' iconSide='left' />
                                    </div>
                                    {/* <table className={`table table-bordered table-stripped`}>
                                      <thead className='table-light'>
                                        <tr>
                                          <th>Select</th>
                                          <th>Sr.No.</th>
                                          <th width={`30%`}>Mail Title</th>
                                          <th width={`60%`}>Mail Subject</th>
                                          <th width={`10%`} className=' text-center'>Action</th>
                                        </tr>
                                      </thead>
                                      {Array.isArray(this.state.email_rows) && this.state.email_rows.length===0 ? 
                                      <tbody>
                                          <tr>
                                            <td colSpan={12}>
                                              <NoRecords />
                                            </td>
                                          </tr>
                                        </tbody> :
                                      <tbody>
                                        {this.state.email_rows.map((row,idx) => {
                                          return (
                                            <tr key={row?.mail_template_id}>
                                              <td >
                                                <div className="d-flex justify-content-center align-items-center">
                                                  <input type="checkbox" className="form-check-input" checked={this.state.selectedEmailTemplate==row?.mail_template_id} onChange={() => this.setState({ selectedEmailTemplate:row?.mail_template_id, errors: { ...this.state.errors , selectedEmailTemplate: '',},})} />
                                                </div>
                                              </td>
                                            <td>{idx + 1}</td>
                                            <td>{row?.mail_template_title}</td>
                                            <td>{row?.mail_subject}</td>
                                            <td className='d-flex justify-content-around'>
                                              {this.state.infoLoading === row?.mail_template_id? 
                                              <button className="btn btn-success btn-load">
                                                  <span className="d-flex align-items-center">
                                                      <span className="spinner-border flex-shrink-0" role="status">
                                                          <span className="visually-hidden">Loading...</span>
                                                      </span>
                                                  </span>
                                              </button>:
                                                  <button onClick={() => this.setState({ infoLoading: row?.mail_template_id }, () => { this.getInfo(idx) })} className="btn-icon btn btn-sm btn-outline-success" > <i className="ri-file-info-line"></i> </button>
                                                  }
                                              
                                            </td>
                                          </tr>
                                          );
                                        })}
                                      </tbody>}
                                      <tfoot className="table-light">
                                        <tr>
                                          <th colSpan={7}>
                                            <div className="d-flex justify-content-between">
                                              <button disabled={ this.state.email_prev === false && this.state.loadingList === false ? true  : false }
                                                type="button"
                                                onClick={() => this.handlePrev("email")}
                                                className={`btn btn-warning btn-label waves-effect waves-light`}
                                              >
                                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                Previous
                                              </button>
                                              <div className="col-md-4" style={{ display: "flex", alignItems: "center" }}>
                                                {
                                                  <small>
                                                    Total Records: {this.state.email_total_records} |
                                                    Total Pages: {this.state.email_total_pages} |
                                                    Current Page: {this.state.email_page}
                                                  </small>
                                                }
                                              </div>
                                              <div className="col-md-2">
                                                <select className="form-select" onChange={(e) => this.handleChange(e,"email")}>
                                                  {Array.from({ length: this.state.email_total_pages },
                                                    (_, i) => (
                                                      <option selected={this.state.email_page === i + 1} key={i} value={i + 1}>
                                                        Page {i + 1}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </div>
                                              <button disabled={ this.state.email_next === false && this.state.loadingList === false ? true : false}
                                                type="button"
                                                onClick={() => this.handleNext("email")}
                                                className={`btn btn-primary btn-label waves-effect right waves-light`}
                                              >
                                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                Next
                                              </button>
                                            </div>
                                          </th>
                                        </tr>
                                      </tfoot>
                                    </table> */}
                                    {/* {this.state.errors.selectedEmailTemplate && (<div className='text-danger'>{this.state.errors.selectedEmailTemplate}</div>)} */}
                                  </div>
                                  <div className="d-flex align-items-start justify-content-between mt-5">
                                    <button type="button" className="btn btn-light btn-label previestab"
                                      onClick={() => this.handlePreviousTab("v-pills-finish-tab")}
                                      data-previous="v-pills-finish-tab"
                                    >
                                      <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                                      Back
                                    </button>
                                    <div className=' d-flex gap-3 align-items-center'>
                                      <button
                                        type="submit"
                                        className="btn btn-info btn-label ms-auto waves-effect waves-light"
                                        onClick={()=> { this.setState({ save_as_draft: true, },()=>{ this.validateSubmit(4) })}} 
                                      >
                                        <i className=" ri-file-list-2-line label-icon align-middle fs-16" />{" "}
                                        Save As Draft
                                      </button>
                                      <button
                                        type="submit"
                                        className="btn btn-success btn-label ms-auto waves-effect waves-light"
                                        onClick={()=> { this.setState({ save_as_draft: false, },()=>{ this.validateSubmit(4) })}} 
                                      >
                                        <i className="ri-mail-send-line label-icon align-middle fs-16" />{" "}
                                        Send
                                      </button>
                                    </div>
                                  </div>
                                  {this.state.isEmailModal && (
                                    <div id="myModal" className="modal show" tabIndex={-1} style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} aria-labelledby="myModalLabel" aria-hidden="true">
                                      <div className="modal-dialog modal-lg">
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5 className="modal-title" id="myModalLabel">Email Template</h5>
                                            <button
                                              onClick={() => {
                                                this.setState({ isEmailModal: false, emailEdit:false, emailPreviewClicked:false, mailTemplateTitle:this.state.email_rows[parseInt(this.state.isEmailModal)]?.mail_template_title,
                                                  mailSubject:this.state.email_rows[parseInt(this.state.isEmailModal)]?.mail_subject,
                                                  mailBody:this.state.email_rows[parseInt(this.state.isEmailModal)]?.mail_body
                                                });
                                              }}
                                              className="btn-close"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                          <div className="modal-body">
                                            <div className='card-body'>
                                              {!this.state.emailEdit?
                                              <div>
                                                <div className='row gy-4'>
                                                  <div className='col-md-12 mb-1 mt-0'>
                                                    <label htmlFor='mailTemplateTitle' className='form-label'>Title:</label>
                                                    <input type='text' id='mailTemplateTitle' name='mailTemplateTitle' disabled
                                                      value={this.state.email_rows[parseInt(this.state.isEmailModal)]?.mail_template_title}
                                                      className={`form-control`}
                                                      placeholder='Template Title'
                                                    />
                                                  </div>
                                                  <div className='col-md-12 mb-0 mt-0'>
                                                    <label htmlFor='mailSubject' className='form-label'>Subject:</label>
                                                    <input type='text' id='mailSubject' name='mailSubject' disabled
                                                      value={this.state.email_rows[parseInt(this.state.isEmailModal)]?.mail_subject}
                                                      className={`form-control`}
                                                      placeholder='Subject'
                                                    />
                                                  </div>
                                                  <div className='col-md-12 mb-3 mt-0'>
                                                    <label htmlFor='mailSubject' className='form-label'>Body:</label>
                                                    <div style={{ border:"1px solid gray", backgroundColor:"#EFF2F7", borderRadius:"10px" }}
                                                    className=' px-3 py-2'
                                                    dangerouslySetInnerHTML={{__html: this.state.email_rows[parseInt(this.state.isEmailModal)]?.mail_body || "",}}
                                                    />
                                                  </div>
                                                  <div>
                                                    {!this.state.emailEdit && (
                                                        <button onClick={() => { this.setState({ emailEdit: true }); }} className="btn btn-warning">
                                                        {"Edit"}
                                                      </button>)}
                                                  </div>
                                                </div>
                                              </div>:
                                              !this.state.emailPreviewClicked?
                                              <>
                                              <div className="d-flex justify-content-between align-items-center pb-3">
                                                  <button type="button" className={`${this.state.mailBody ? ('') : 'd-none'} btn btn-primary btn-label`}
                                                  onClick={()=> ( this.setState({ emailPreviewClicked:true }, ()=>{ this.templatePreview("email") }))}>
                                                    Preview<i className="ri-eye-line label-icon align-middle fs-16" />
                                                  </button>
                                                  <button type="button" className="btn btn-primary waves-effect right waves-light btn-label" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
                                                    <i className="ri-code-s-slash-line label-icon align-middle fs-16" />Placeholder Keys
                                                  </button>
                                              </div>
                                              <div className="offcanvas offcanvas-end" tabIndex={-1} id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                                                <div className="offcanvas-header">
                                                    <h5 id="offcanvasRightLabel"> Placeholder Keys</h5>
                                                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"/>
                                                </div>
                                                <div className="offcanvas-body">
                                                  <table class="table table-hover table-bordered border-primary table-nowrap">
                                                    <thead className="bg-primary text-light bg-gradient">
                                                        <tr>
                                                            <th scope="col">Names</th>
                                                            <th scope="col">Code</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                      { offerLetterCheatCode?.map((val)=>{
                                                          return (
                                                            <tr>
                                                                <td>{val?.name}</td>
                                                                <td onClick={() => this.handleCopyClick(val?.code)} style={{ cursor: "pointer" }}>{val?.code}</td>
                                                            </tr>
                                                          )
                                                        })
                                                      }
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                              <form className=' mt-3' onSubmit={()=> this.handleEmail()} >
                                                <div className='row gy-4'>
                                                  <div className='col-md-12 mb-1 mt-0'>
                                                  <h5 className=' py-1'>Title: {this.state.mailTemplateTitle}</h5>
                                                  <h5 className=' py-1'>Subject: {this.state.mailSubject}</h5>
                                                    {/* <label htmlFor='mailTemplateTitle' className='form-label'>
                                                      Title:
                                                    </label>
                                                    <input
                                                      type='text'
                                                      id='mailTemplateTitle'
                                                      name='mailTemplateTitle'
                                                      value={this.state.mailTemplateTitle}
                                                      // onChange={e => this.handleInputChange(e)}
                                                      className={`form-control ${
                                                        this.state.errors.mailTemplateTitle ? 'is-invalid' : ''
                                                      }`}
                                                      placeholder='Enter Template Title'
                                                    /> */}

                                                    {/* {this.state.errors.mailTemplateTitle && (
                                                      <div className='text-danger'>
                                                        {this.state.errors.mailTemplateTitle}
                                                      </div>
                                                    )} */}
                                                  </div>
                                                  {/* <div className='col-md-12 mt-0'> */}
                                                  {/* <h5 className=' py-1'>Subject: {this.state.mailSubject}</h5> */}
                                                    {/* <label htmlFor='mailSubject' className='form-label'>
                                                      Subject:
                                                    </label>
                                                    <input
                                                      type='text'
                                                      id='mailSubject'
                                                      name='mailSubject'
                                                      value={this.state.mailSubject}
                                                      onChange={e =>
                                                        this.handleInputChange(e)
                                                      }
                                                      className={`form-control ${
                                                        this.state.errors.mailSubject ? 'is-invalid' : ''
                                                      }`}
                                                      placeholder='Enter Subject'
                                                    /> */}
{/* 
                                                    {this.state.errors.mailSubject && (
                                                      <div className='text-danger'>
                                                        {this.state.errors.mailSubject}
                                                      </div>
                                                    )} */}
                                                  {/* </div> */}
                                                </div>
                                                <div className='col-md-12'>
                                                  <div>
                                                    <CKEditor
                                                    editor={ClassicEditor}
                                                    data={this.state.mailBody}
                                                    name={'mailBody'}
                                                    onChange={this.handleEditorEmailChange}
                                                    />
                                                  </div>
                                                  {this.state.errors.mailBody && (
                                                    <div style={{ fontSize: '12px' }} className=' text-danger'> {this.state.errors.mailBody}</div>
                                                  )}
                                                  <div style={{ marginTop: '30px', marginLeft: 'Auto' }}>
                                                    <button style={{ marginRight:"10px" }} type='submit'
                                                    className={`btn btn-primary btn-label waves-effect right waves-light float-right`}>
                                                      <i className={`ri-save-line label-icon align-middle fs-16 ms-2`}/>
                                                      Save
                                                    </button>
                                                    <button onClick={()=> this.setState({ emailEdit:false})}
                                                    className={`btn btn-danger btn-label waves-effect right waves-light float-right`}>
                                                      <i className={`ri-save-line label-icon align-middle fs-16 ms-2`}/>
                                                      Cancel
                                                    </button>
                                                  </div>
                                                </div>
                                              </form>
                                              </>:
                                              <div>
                                                <div className='row gy-4'>
                                                  <button onClick={() => { this.setState({ emailPreviewClicked: false });}} className="btn btn-warning">
                                                    Editor
                                                  </button>
                                                  <div className='col-md-12 mb-1 mt-0'>
                                                    <label htmlFor='mailTemplateTitle' className='form-label'>Title:</label>
                                                    <input type='text' id='mailTemplateTitle' name='mailTemplateTitle' disabled
                                                      value={this.state.email_rows[parseInt(this.state.isEmailModal)]?.mail_template_title}
                                                      className={`form-control`}
                                                      placeholder='Template Title'
                                                    />
                                                  </div>
                                                  <div className='col-md-12 mb-0 mt-0'>
                                                    <label htmlFor='mailSubject' className='form-label'>Subject:</label>
                                                    <input type='text' id='mailSubject' name='mailSubject' disabled
                                                      value={this.state.email_rows[parseInt(this.state.isEmailModal)]?.mail_subject}
                                                      className={`form-control`}
                                                      placeholder='Subject'
                                                    />
                                                  </div>
                                                  <div className='col-md-12 mb-3 mt-0'>
                                                    <label htmlFor='mailSubject' className='form-label'>Body:</label>
                                                    <div style={{ border:"1px solid gray", backgroundColor:"#EFF2F7", borderRadius:"10px",}}
                                                    className=' px-3 py-2'
                                                    dangerouslySetInnerHTML={{__html: this.state.email_preview || ""}}
                                                    />
                                                  </div>
                                                  <div>
                                                    {!this.state.emailEdit && (
                                                        <button onClick={() => { this.setState({ emailEdit: true }); }} className="btn btn-warning">
                                                        Editor
                                                      </button>)}
                                                  </div>
                                                </div>
                                              </div>
                                              }
                                            </div>
                                          </div>
                                          <div className="modal-footer">
                                            <button onClick={() => { this.setState({ isEmailModal: false , emailEdit:false, emailPreviewClicked:false}); }} className="btn btn-light" >
                                              Close
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>) : (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "90vh" }}>
            <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
          </div>)}
        
        {/* <div id="letter-content" style={{ position: "absolute", left: "-9999px" }}>
          {renderPages(this.state?.company_letter_content,this.state?.letterhead_url,this.state?.markings)} 
        </div> */}
      </>
    )
  }
}

export default withRouter(GuestEmployeeSandBox);

